//English
module.exports = {
	common: {
		common_0: "加载中",
		common_1: "提示",
		common_2: "取消",
		common_3: "确定",
		common_4: "预览",
		common_5: "操作成功",
		common_6: "网络连接失败",
		common_7: "房源添加成功!",
		common_8: "客户添加成功!",

		common_InOffset: "下拉刷新",
		common_OutOffset: "释放刷新",
		common_Loading: "加载中...",
		common_NoMore: "没有更多了"
	},
	Message: {
		// hello: 'hello',
		// about: 'about',
		// welcome: "Welcome",
		Message_01: "Save successfully。",
		Message_02: "Save failed。",
		Message_03: "没有满足条件的数据。",
		Message_04: "打印的数据超过了1万条，请追加检索条件。",
		Message_05: "This is something that must be entered.",		
	},
	login: {
		login_0: "MANECU管理平台",
		login_1: "登录",
		login_2: "换一换",
		login_3: "忘记密码？",
		login_4: "记住账号",
		login_5: "请输入邮箱",
		login_6: "请输入6-18位密码",
		login_7: "请输入验证码",
		login_8: "验证码不正确",
		login_9: "邮箱格式不正确",
		login_10: "请输入密码",
		login_11: "密码长度在 6 到 18 位之间",
		login_12: "只能输入6-18个字母、数字、下划线",
		login_13: "登录成功",
		login_14: "该邮箱未注册",
		login_15: "邮箱或密码错误",
		login_16: "网络请求失败",
		login_17: "日本語",
		login_18: "简体中文",
		login_19: "繁体中文",
		login_20: "English"
	},
	header: {
		header_0: "MANECU管理平台",
		header_1: "日本語",
		header_2: "简体中文",
		header_3: "繁体中文",
		header_4: "English",
		header_5: "取消全屏",
		header_6: "全屏",
		header_7: "有",
		header_8: "条未读消息",
		header_9: "消息中心",
		header_10: "个人资料",
		header_11: "退出登录"
	},
	tags: {
		tags_0: "标签选项",
		tags_1: "关闭其他",
		tags_2: "关闭所有"
	},
	sidebar: {
		sidebar_0: "系统首页",
		sidebar_1: "菜单管理",
		sidebar_2: "角色管理",
		sidebar_3: "用户管理",
		sidebar_4: "会社管理",
		
		sidebar_5: "商品移动",
		sidebar_6: "商品移动出库处理",
		sidebar_7: "商品移動履歴",
		

	},
	forgetpwd: {
		forgetpwd_0: "Retrieve password",
		forgetpwd_1: "Please enter email",
		forgetpwd_2: "Please enter the verification code",
		forgetpwd_3: "Please enter a new password of 6-18 digits",
		forgetpwd_4: "Password length is between 6-18 bits",
		forgetpwd_5: "Get verification code",
		forgetpwd_6: "Inconsistent with input password",
		forgetpwd_7: "Determine",
		forgetpwd_8: "I remind of it!",
		forgetpwd_9: "Direct login",
		forgetpwd_10: "Verification code cannot be empty",
		forgetpwd_11: "Please enter the correct email format",
		forgetpwd_12: "Seconds later",
		forgetpwd_13: "Regain",
		forgetpwd_14: "Verification code error",
		forgetpwd_15: "Login successfully",
		forgetpwd_16: "Please enter account number and password",
		forgetpwd_17: "Mailbox cannot be empty",
		forgetpwd_18: "Incorrect verification code",
		forgetpwd_19: "Modified success",
		forgetpwd_20: "Please register this email first",
		forgetpwd_21: "Verification code has timed out",
		forgetpwd_22: "Modification failed",
		forgetpwd_23: "Please repeat the 6-18 digit new password",
		forgetpwd_24: "Mailbox does not match verification code",
		forgetpwd_25: "Verification code must be six digits",
		forgetpwd_26: "Acquisition"
	},
	usersList: {
		usersList_0: "用户管理",
		usersList_1: "请选择角色",
		usersList_2: "请搜索所属店铺",
		usersList_3: "请搜索所属代理商",
		usersList_4: "请搜索用户ID/昵称/邮箱",
		usersList_5: "开始日期",
		usersList_6: "结束日期",
		usersList_7: "搜索",
		usersList_8: "批量删除",
		usersList_9: "导出Excel",
		usersList_10: "新增",
		usersList_11: "昵称",
		usersList_12: "角色",
		usersList_13: "所属店铺",
		usersList_14: "所属代理商",
		usersList_15: "邮箱",
		usersList_16: "新增时间",
		usersList_17: "操作",
		usersList_18: "查看",
		usersList_19: "编辑",
		usersList_20: "删除",
		usersList_21: "请求失败",
		usersList_22: "您确定要删除吗？",
		usersList_23: "提示",
		usersList_24: "删除失败",
		usersList_25: "删除成功",
		usersList_26: "批量删除成功",
		usersList_27: "请您在列表中勾选您要删除的用户信息",
		usersList_28: "此操作将导出excel文件, 是否继续?",
		usersList_29: "确定",
		usersList_30: "取消",
		usersList_31: "导入中，请稍候...",
		usersList_32: "用户ID"
	},
	addUsers: {
		addUsers_0: "用户管理",
		addUsers_1: "用户新增",
		addUsers_2: "头像：",
		addUsers_3: "邮箱号：",
		addUsers_4: "请输入邮箱号",
		addUsers_5: "初始密码：",
		addUsers_6: "请设置初始密码",
		addUsers_7: "昵称：",
		addUsers_8: "请输入昵称",
		addUsers_9: "姓名：",
		addUsers_10: "请输入姓名",
		addUsers_11: "拼音：",
		addUsers_12: "请输入拼音",
		addUsers_13: "角色：",
		addUsers_14: "请选择角色",
		addUsers_15: "所属店铺：",
		addUsers_16: "请搜索所属店铺",
		addUsers_17: "所属代理商：",
		addUsers_18: "请搜索所属代理商",
		addUsers_19: "电话：",
		addUsers_20: "请输入手机号",
		addUsers_21: "性别：",
		addUsers_22: "男",
		addUsers_23: "女",
		addUsers_24: "返回",
		addUsers_25: "提交",
		addUsers_26: "长度在1-50之间",
		addUsers_27: "只能输入数字以及横线",
		addUsers_28: "请输入邮箱",
		addUsers_29: "邮箱格式不正确",
		addUsers_30: "请输入密码",
		addUsers_31: "密码长度在 6 到 18 位之间",
		addUsers_32: "只能输入6-18个字母、数字、下划线",
		addUsers_33: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		addUsers_34: "上传产品图片大小不能超过 2MB!",
		addUsers_35: "请求失败",
		addUsers_36: "邮箱不能重复注册",
		addUsers_37: "用户新增失败",
		addUsers_38: "用户新增成功",
		addUsers_39: "表单验证失败"
	},
	editUsers: {
		editUsers_0: "用户管理",
		editUsers_1: "用户编辑",
		editUsers_2: "头像：",
		editUsers_3: "邮箱号：",
		editUsers_4: "请输入邮箱号",
		editUsers_5: "昵称：",
		editUsers_6: "请输入昵称",
		editUsers_7: "姓名：",
		editUsers_8: "请输入姓名",
		editUsers_9: "拼音：",
		editUsers_10: "请输入拼音",
		editUsers_11: "角色：",
		editUsers_12: "请选择角色",
		editUsers_13: "所属店铺：",
		editUsers_14: "请搜索所属店铺",
		editUsers_15: "所属代理商：",
		editUsers_16: "请搜索所属代理商",
		editUsers_17: "电话：",
		editUsers_18: "请输入手机号",
		editUsers_19: "性别：",
		editUsers_20: "男",
		editUsers_21: "女",
		editUsers_22: "返回",
		editUsers_23: "保存",
		editUsers_24: "长度在1-50之间",
		editUsers_25: "只能输入数字以及横线",
		editUsers_26: "请输入邮箱号！邮箱号为必填项",
		editUsers_27: "邮箱格式不正确",
		editUsers_28: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		editUsers_29: "上传产品图片大小不能超过 2MB!",
		editUsers_30: "请求失败",
		editUsers_31: "无数据",
		editUsers_32: "用户编辑失败",
		editUsers_33: "用户编辑成功",
		editUsers_34: "表单验证失败"
	},
	usersDetails: {
		usersDetails_0: "用户管理",
		usersDetails_1: "用户查看",
		usersDetails_2: "头像：",
		usersDetails_3: "邮箱号：",
		usersDetails_4: "请输入邮箱号",
		usersDetails_5: "昵称：",
		usersDetails_6: "请输入昵称",
		usersDetails_7: "姓名：",
		usersDetails_8: "请输入姓名",
		usersDetails_9: "拼音：",
		usersDetails_10: "请输入拼音",
		usersDetails_11: "角色：",
		usersDetails_12: "请选择角色",
		usersDetails_13: "所属店铺：",
		usersDetails_14: "请搜索所属店铺",
		usersDetails_15: "所属代理商：",
		usersDetails_16: "请搜索所属代理商",
		usersDetails_17: "电话：",
		usersDetails_18: "请输入手机号",
		usersDetails_19: "性别：",
		usersDetails_20: "男",
		usersDetails_21: "女",
		usersDetails_22: "返回",
		usersDetails_23: "请求失败",
		usersDetails_24: "无数据"
	},
	shopsList: {
		shopsList_0: "店铺管理",
		shopsList_1: "请搜索店铺名称/店铺ID",
		shopsList_2: "删除状态",
		shopsList_3: "请搜索会社名称",
		shopsList_4: "请选择分类",
		shopsList_5: "请选择审核状态",
		shopsList_6: "搜索",
		shopsList_7: "批量删除",
		shopsList_8: "导出Excel",
		shopsList_9: "新增",
		shopsList_10: "店铺ID",
		shopsList_11: "店铺名称",
		shopsList_12: "会社名称",
		shopsList_13: "套餐数量",
		shopsList_14: "分类",
		shopsList_15: "返点比例",
		shopsList_16: "审核状态",
		shopsList_17: "未认证",
		shopsList_18: "审核中",
		shopsList_19: "审核已通过",
		shopsList_20: "审核未通过",
		shopsList_21: "操作",
		shopsList_22: "查看",
		shopsList_23: "编辑",
		shopsList_24: "删除",
		shopsList_25: "请求失败",
		shopsList_26: "您确定要操作吗？",
		shopsList_27: "提示",
		shopsList_28: "操作失败",
		shopsList_29: "操作成功",
		shopsList_30: "批量删除成功",
		shopsList_31: "请您在列表中勾选您要删除的店铺信息",
		shopsList_32: "此操作将导出excel文件, 是否继续?",
		shopsList_33: "确定",
		shopsList_34: "取消",
		shopsList_35: "停用",
		shopsList_36: "恢复"
	},
	addShops: {
		addShops_0: "店铺管理",
		addShops_1: "新增店铺",
		addShops_2: "会社名称：",
		addShops_3: "请选择",
		addShops_4: "可绑定已有会社，如没有则忽略此项",
		addShops_5: "绑定已有会社",
		addShops_6: "店铺图片：",
		addShops_7: "上传店铺LOGO图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB",
		addShops_8: "店铺名称：",
		addShops_9: "请输入店铺名称",
		addShops_10: "拼音：",
		addShops_11: "请输入拼音",
		addShops_12: "邮便番号：",
		addShops_13: "请输入邮便番号",
		addShops_14: "电话号：",
		addShops_15: "请输入电话号",
		addShops_16: "店铺分类：",
		addShops_17: "返点比例：",
		addShops_18: "请输入",
		addShops_19: "建议返点数：",
		addShops_20: "之间",
		addShops_21: "人均：",
		addShops_22: "请输入人均",
		addShops_23: "日元",
		addShops_24: "当前营业状态：",
		addShops_25: "请选择当前营业状态",
		addShops_26: "场所设施：",
		addShops_27: "包间",
		addShops_28: "WIFI",
		addShops_29: "可吸烟",
		addShops_30: "停车位",
		addShops_31: "儿童座椅",
		addShops_32: "可只预约座位：",
		addShops_33: "坐位可取消时间：",
		addShops_34: "提前",
		addShops_35: "天",
		addShops_36: "小时",
		addShops_37: "注：预订座位成功后，导游提前多久可取消订单",
		addShops_38: "营业时间：",
		addShops_39: "日期设置：",
		addShops_40: "至",
		addShops_41: "营业状态：",
		addShops_42: "时间段设置：",
		addShops_43: "开始时间",
		addShops_44: "结束时间",
		addShops_45: "选择时间范围",
		addShops_46: "最后点餐：",
		addShops_47: "选择时间",
		addShops_48: "特殊时间：",
		addShops_49: "环境图片：",
		addShops_50: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB。",
		addShops_51: "所在地区：",
		addShops_52: "详细地址：",
		addShops_53: "请输入详细地址",
		addShops_54: "获取坐标",
		addShops_55: "经度：",
		addShops_56: "请输入经度",
		addShops_57: "纬度：",
		addShops_58: "请输入纬度",
		addShops_59: "菜单图片：",
		addShops_60: "最多可以上传9张图片，建议尺寸在200px*200px",
		addShops_61: "店铺简介：",
		addShops_62: "请输入店铺简介(最多输入500个字)",
		addShops_63: "预定须知：",
		addShops_64: "请输入预定须知",
		addShops_65: "店铺认证：",
		addShops_66: "上传店铺认证",
		addShops_67: "审核状态：",
		addShops_68: "返回",
		addShops_69: "提交",
		addShops_70: "邮箱邀请码：",
		addShops_71: "确定",
		addShops_72: "店铺认证详情页",
		addShops_73: "店铺认证图片：（点击图片可放大）",
		addShops_74: "长度在1-50之间",
		addShops_75: "请输入电话号",
		addShops_76: "只能输入数字以及横线",
		addShops_77: "请输入邀请码",
		addShops_78: "只能输入数字",
		addShops_79: "否",
		addShops_80: "是",
		addShops_81: "请上传店铺图片",
		addShops_82: "请选择店铺分类",
		addShops_83: "请选择当前营业状态",
		addShops_84: "请求失败",
		addShops_85: "该邀请码已经使用，请更换其他邀请码",
		addShops_86: "该邀请码不存在",
		addShops_87: "上传店铺图片只能是 JPG/PNG/JPEG 格式!",
		addShops_88: "上传店铺图片大小不能超过 4MB!",
		addShops_89: "上传环境图片只能是 JPG/PNG/JPEG 格式!",
		addShops_90: "上传环境图片大小不能超过 4MB!",
		addShops_91: "上传菜单图片只能是 JPG/PNG/JPEG 格式!",
		addShops_92: "上传菜单图片大小不能超过 4MB!",
		addShops_93: "上传店铺认证图片只能是 JPG/PNG/JPEG 格式!",
		addShops_94: "上传店铺认证图片大小不能超过 4MB!",
		addShops_95: "最多只能上传9图片!",
		addShops_96: "最多只能上传5图片!",
		addShops_97: "新增失败",
		addShops_98: "新增成功",
		addShops_99: "更新验证状态失败",
		addShops_100: "表单验证失败",
		addShops_101: "请输入返点比例",
		addShops_102: "请输入人均消费",
		addShops_103: "请选中可只预约座位",
		addShops_104: "请选择所在地区",
		addShops_105: "经度整数部分为0-180,小数部分为0到6位!",
		addShops_106: "纬度整数部分为0-90,小数部分为0到6位!",
		addShops_107: "株式会社",
		addShops_108: "添加店长",
		addShops_109: "昵称：",
		addShops_110: "邮箱号：",
		addShops_111: "密码：",
		addShops_112: "注：初始密码123456",
		addShops_113: "角色："	
	},
	editShops: {
		editShops_0: "店铺管理",
		editShops_1: "编辑店铺",
		editShops_2: "店铺ID：",
		editShops_3: "会社名称：",
		editShops_4: "请选择",
		editShops_5: "编辑会社详情",
		editShops_6: "变更所属会社",
		editShops_7: "可绑定已有会社，如没有则忽略此项",
		editShops_8: "绑定已有会社",
		editShops_9: "店铺图片：",
		editShops_10: "上传店铺LOGO图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB",
		editShops_11: "店铺名称：",
		editShops_12: "请输入店铺名称",
		editShops_13: "拼音：",
		editShops_14: "请输入拼音",
		editShops_15: "邮便番号：",
		editShops_16: "请输入邮便番号",
		editShops_17: "电话号：",
		editShops_18: "请输入电话号",
		editShops_19: "店铺分类：",
		editShops_20: "返点比例：",
		editShops_21: "请输入",
		editShops_22: "建议返点数：",
		editShops_23: "之间",
		editShops_24: "人均：",
		editShops_25: "请输入人均",
		editShops_26: "日元",
		editShops_27: "当前营业状态：",
		editShops_28: "请选择当前营业状态",
		editShops_29: "场所设施：",
		editShops_30: "包间",
		editShops_31: "WIFI",
		editShops_32: "可吸烟",
		editShops_33: "停车位",
		editShops_34: "儿童座椅",
		editShops_35: "可只预约座位：",
		editShops_36: "坐位可取消时间：",
		editShops_37: "提前",
		editShops_38: "天",
		editShops_39: "小时",
		editShops_40: "注：预订座位成功后，导游提前多久可取消订单",
		editShops_41: "营业时间：",
		editShops_42: "日期设置：",
		editShops_43: "至",
		editShops_44: "营业状态：",
		editShops_45: "时间段设置：",
		editShops_46: "开始时间",
		editShops_47: "结束时间",
		editShops_48: "选择时间范围",
		editShops_49: "最后点餐：",
		editShops_50: "选择时间",
		editShops_51: "特殊时间：",
		editShops_52: "日期设置：",
		editShops_53: "环境图片：",
		editShops_54: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB。",
		editShops_55: "所在地区：",
		editShops_56: "详细地址：",
		editShops_57: "请输入详细地址",
		editShops_58: "获取坐标",
		editShops_59: "经度：",
		editShops_60: "请输入经度",
		editShops_61: "纬度：",
		editShops_62: "请输入纬度",
		editShops_63: "菜单图片：",
		editShops_64: "最多可以上传9张图片，建议尺寸在200px*200px",
		editShops_65: "店铺简介：",
		editShops_66: "请输入店铺简介(最多输入500个字)",
		editShops_67: "预定须知：",
		editShops_68: "请输入预定须知",
		editShops_69: "店铺认证：",
		editShops_70: "店铺认证详情",
		editShops_71: "添加店员：",
		editShops_72: "添加店员",
		editShops_73: "审核状态：",
		editShops_74: "审核备注：",
		editShops_75: "返回",
		editShops_76: "保存",
		editShops_77: "邮箱邀请码：",
		editShops_78: "确定",
		editShops_79: "店铺认证详情页",
		editShops_80: "店铺认证图片：（点击图片可放大）",
		editShops_81: "昵称：",
		editShops_82: "邮箱号：",
		editShops_83: "密码：",
		editShops_84: "注：初始密码123456",
		editShops_85: "角色：",
		editShops_86: "长度在1-50之间",
		editShops_87: "只能输入数字以及横线",
		editShops_88: "请输入邀请码",
		editShops_89: "只能输入数字",
		editShops_90: "请输入邮箱",
		editShops_91: "邮箱格式不正确",
		editShops_92: "否",
		editShops_93: "是",
		editShops_94: "请上传店铺图片",
		editShops_95: "请选择店铺分类",
		editShops_96: "请选择当前营业状态",
		editShops_97: "请输入返点比例",
		editShops_98: "请输入人均消费",
		editShops_99: "请选中可只预约座位",
		editShops_100: "请选择所在地区",
		editShops_101: "请求失败",
		editShops_102: "该邀请码已经使用，请更换其他邀请码",
		editShops_103: "该邀请码不存在",
		editShops_104: "上传店铺图片只能是 JPG/PNG/JPEG 格式!",
		editShops_105: "上传店铺图片大小不能超过 4MB!",
		editShops_106: "上传环境图片只能是 JPG/PNG/JPEG 格式!",
		editShops_107: "上传环境图片大小不能超过 4MB!",
		editShops_108: "上传菜单图片只能是 JPG/PNG/JPEG 格式!",
		editShops_109: "上传菜单图片大小不能超过 4MB!",
		editShops_110: "上传店铺认证图片只能是 JPG/PNG/JPEG 格式!",
		editShops_111: "上传店铺认证图片大小不能超过 4MB!",
		editShops_112: "最多只能上传9图片!",
		editShops_113: "最多只能上传5图片!",
		editShops_114: "无数据",
		editShops_115: "邮箱不能重复注册",
		editShops_116: "添加店员失败",
		editShops_117: "添加店员成功",
		editShops_118: "编辑失败",
		editShops_119: "编辑成功",
		editShops_120: "更新验证状态失败",
		editShops_121: "表单验证失败",
		editShops_122: "审核结果",
		editShops_123: "删除成功"
	},

	shopsDetails: {
		shopsDetails_0: "店铺管理",
		shopsDetails_1: "查看店铺",
		shopsDetails_2: "店铺ID：",
		shopsDetails_3: "会社名称：",
		shopsDetails_4: "可绑定已有会社，如没有则忽略此项",
		shopsDetails_5: "查看会社详情",
		shopsDetails_6: "店铺图片：",
		shopsDetails_7: "上传店铺LOGO图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB",
		shopsDetails_8: "店铺名称：",
		shopsDetails_9: "请输入店铺名称",
		shopsDetails_10: "拼音：",
		shopsDetails_11: "请输入拼音",
		shopsDetails_12: "邮便番号：",
		shopsDetails_13: "请输入邮便番号",
		shopsDetails_14: "电话号：",
		shopsDetails_15: "请输入电话号",
		shopsDetails_16: "店铺分类：",
		shopsDetails_17: "返点比例：",
		shopsDetails_18: "请输入",
		shopsDetails_19: "人均：",
		shopsDetails_20: "请输入人均",
		shopsDetails_21: "日元",
		shopsDetails_22: "当前营业状态：",
		shopsDetails_23: "请选择当前营业状态",
		shopsDetails_24: "场所设施：",
		shopsDetails_25: "包间",
		shopsDetails_26: "WIFI",
		shopsDetails_27: "可吸烟",
		shopsDetails_28: "停车位",
		shopsDetails_29: "儿童座椅",
		shopsDetails_30: "可只预约座位：",
		shopsDetails_31: "请选择",
		shopsDetails_32: "坐位可取消时间：",
		shopsDetails_33: "提前",
		shopsDetails_34: "天",
		shopsDetails_35: "小时",
		shopsDetails_36: "注：预订座位成功后，导游提前多久可取消订单",
		shopsDetails_37: "营业时间：",
		shopsDetails_38: "日期设置：",
		shopsDetails_39: "至",
		shopsDetails_40: "营业状态：",
		shopsDetails_41: "时间段设置：",
		shopsDetails_42: "开始时间",
		shopsDetails_43: "结束时间",
		shopsDetails_44: "选择时间范围",
		shopsDetails_45: "最后点餐：",
		shopsDetails_46: "选择时间",
		shopsDetails_47: "特殊时间：",
		shopsDetails_48: "日期设置：",
		shopsDetails_49: "环境图片：",
		shopsDetails_50: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过4MB。",
		shopsDetails_51: "所在地区：",
		shopsDetails_52: "详细地址：",
		shopsDetails_53: "请输入详细地址",
		shopsDetails_54: "获取坐标",
		shopsDetails_55: "经度：",
		shopsDetails_56: "请输入经度",
		shopsDetails_57: "纬度：",
		shopsDetails_58: "请输入纬度",
		shopsDetails_59: "菜单图片：",
		shopsDetails_60: "最多可以上传9张图片，建议尺寸在200px*200px",
		shopsDetails_61: "店铺简介：",
		shopsDetails_62: "请输入店铺简介(最多输入500个字)",
		shopsDetails_63: "预定须知：",
		shopsDetails_64: "请输入预定须知",
		shopsDetails_65: "店铺认证：",
		shopsDetails_66: "店铺认证详情",
		shopsDetails_67: "添加店员：",
		shopsDetails_68: "添加店员",
		shopsDetails_69: "审核状态：",
		shopsDetails_70: "审核备注：",
		shopsDetails_71: "返回",
		shopsDetails_72: "店铺认证详情页",
		shopsDetails_73: "店铺认证图片",
		shopsDetails_74: "确定",
		shopsDetails_75: "昵称：",
		shopsDetails_76: "邮箱号：",
		shopsDetails_77: "密码：",
		shopsDetails_78: "注：初始密码123456",
		shopsDetails_79: "角色：",
		shopsDetails_80: "长度在1-50之间",
		shopsDetails_81: "只能输入数字以及横线",
		shopsDetails_82: "请输入邀请码",
		shopsDetails_83: "只能输入数字",
		shopsDetails_84: "请输入邮箱",
		shopsDetails_85: "邮箱格式不正确",
		shopsDetails_86: "否",
		shopsDetails_87: "是",
		shopsDetails_88: "请上传店铺图片",
		shopsDetails_89: "请选择店铺分类",
		shopsDetails_90: "请选择当前营业状态",
		shopsDetails_91: "请输入返点比例",
		shopsDetails_92: "请输入人均消费",
		shopsDetails_93: "请选中可只预约座位",
		shopsDetails_94: "请选择所在地区",
		shopsDetails_95: "请输入详细地址",
		shopsDetails_96: "请求失败",
		shopsDetails_97: "无数据",
		shopsDetails_98: "邮箱不能重复注册",
		shopsDetails_99: "添加店员失败",
		shopsDetails_100: "添加店员成功"
	},
	companysList: {
		companysList_0: "会社管理",
		companysList_1: "请搜索会社名称/会社ID/电话/邮便番号",
		companysList_2: "开始日期",
		companysList_3: "结束日期",
		companysList_4: "搜索",
		companysList_5: "批量删除",
		companysList_6: "导出Excel",
		companysList_7: "新增",
		companysList_8: "会社ID",
		companysList_9: "会社名称",
		companysList_10: "郵便番号",
		companysList_11: "电话",
		companysList_12: "店铺数量",
		companysList_13: "新增时间",
		companysList_14: "操作",
		companysList_15: "查看",
		companysList_16: "编辑",
		companysList_17: "删除",
		companysList_18: "请求失败",
		companysList_19: "您确定要操作吗？",
		companysList_20: "提示",
		companysList_21: "操作失败",
		companysList_22: "操作成功",
		companysList_23: "批量删除成功",
		companysList_24: "请您在列表中勾选您要删除的会社信息",
		companysList_25: "此操作将导出excel文件, 是否继续?",
		companysList_26: "确定",
		companysList_27: "取消",
		companysList_28: "恢复",
		companysList_29: "删除状态"
	},
	addCompanys: {
		addCompanys_0: "会社管理",
		addCompanys_1: "会社新增",
		addCompanys_2: "会社名称：",
		addCompanys_3: "请输入会社名称",
		addCompanys_4: "拼音：",
		addCompanys_5: "请输入拼音",
		addCompanys_6: "会社種類(前)：",
		addCompanys_7: "请选择会社種類(前)",
		addCompanys_8: "会社種類(後)：",
		addCompanys_9: "请选择会社種類(後)",
		addCompanys_10: "郵便番号：",
		addCompanys_11: "请输入郵便番号",
		addCompanys_12: "電話：",
		addCompanys_13: "请输入電話",
		addCompanys_14: "都道府県：",
		addCompanys_15: "请选择都道府県",
		addCompanys_16: "住所：",
		addCompanys_17: "请输入住所",
		addCompanys_18: "传真：",
		addCompanys_19: "请输入传真",
		addCompanys_20: "网站：",
		addCompanys_21: "请输入网站",
		addCompanys_22: "代表者名：",
		addCompanys_23: "请输入代表者名",
		addCompanys_24: "代表者名(拼音)：",
		addCompanys_25: "请输入代表者名(拼音)",
		addCompanys_26: "返回",
		addCompanys_27: "提交",
		addCompanys_28: "长度在1-50之间",
		addCompanys_29: "只能输入数字以及横线",
		addCompanys_30: "请输入社名称",
		addCompanys_31: "请求失败",
		addCompanys_32: "新增失败",
		addCompanys_33: "新增成功",
		addCompanys_34: "表单验证失败",
		addCompanys_35: "只能输入英文字母和日文"
	},
	editCompanys: {
		editCompanys_0: "会社管理",
		editCompanys_1: "会社编辑",
		editCompanys_2: "会社ID：",
		editCompanys_3: "请输入会社ID",
		editCompanys_4: "会社名称：",
		editCompanys_5: "请输入会社名称",
		editCompanys_6: "拼音：",
		editCompanys_7: "请输入拼音",
		editCompanys_8: "会社種類(前)：",
		editCompanys_9: "请选择会社種類(前)",
		editCompanys_10: "会社種類(後)：",
		editCompanys_11: "请选择会社種類(後)",
		editCompanys_12: "郵便番号：",
		editCompanys_13: "请输入郵便番号",
		editCompanys_14: "電話：",
		editCompanys_15: "请输入電話",
		editCompanys_16: "都道府県：",
		editCompanys_17: "请选择都道府県",
		editCompanys_18: "住所：",
		editCompanys_19: "请输入住所",
		editCompanys_20: "传真：",
		editCompanys_21: "请输入传真",
		editCompanys_22: "网站：",
		editCompanys_23: "请输入网站",
		editCompanys_24: "代表者名：",
		editCompanys_25: "请输入代表者名",
		editCompanys_26: "代表者名(拼音)：",
		editCompanys_27: "请输入代表者名(拼音)",
		editCompanys_28: "信用卡绑定：",
		editCompanys_29: "绑定信用卡信息",
		editCompanys_30: "信用卡未绑定",
		editCompanys_31: "信用卡绑定成功",
		editCompanys_32: "信用卡绑定失败",
		editCompanys_33: "返回",
		editCompanys_34: "保存",
		editCompanys_35: "信用卡绑定详情",
		editCompanys_36: "カード番号：",
		editCompanys_37: "セキュリティコード：",
		editCompanys_38: "有効期限：",
		editCompanys_39: "カード会員名（名）：",
		editCompanys_40: "カード会員名（姓）：",
		editCompanys_41: "メールアドレス：",
		editCompanys_42: "電話番号：",
		editCompanys_43: "提交",
		editCompanys_44: "长度在1-50之间",
		editCompanys_45: "只能输入数字以及横线",
		editCompanys_46: "请输入社名称",
		editCompanys_47: "请求失败",
		editCompanys_48: "表单验证失败",
		editCompanys_49: "无数据",
		editCompanys_50: "编辑失败",
		editCompanys_51: "编辑成功",
		editCompanys_52: "提示",
		editCompanys_53: "确定",
		editCompanys_54: "卡号（无效）",
		editCompanys_55: "卡号位数",
		editCompanys_56: "请确认卡号",
		editCompanys_57: "卡有效期限（无效）",
		editCompanys_58: "卡有效期限位数",
		editCompanys_59: "卡有效期限月",
		editCompanys_60: "卡安全码（无效）",
		editCompanys_61: "卡安全码位数",
		editCompanys_62: "持卡人名（无效）",
		editCompanys_63: "持卡人名（字数）",
		editCompanys_64: "持卡人姓（无效）",
		editCompanys_65: "持卡人姓（字数）",
		editCompanys_66: "令牌（无效）",
		editCompanys_67: "令牌长度",
		editCompanys_68: "商店编号（无效）",
		editCompanys_69: "商店编号位数",
		editCompanys_70: "会员编号位数",
		editCompanys_71: "邮件地址（无效）",
		editCompanys_72: "邮箱地址位数",
		editCompanys_73: "电话号码（无效）",
		editCompanys_74: "电话号码位数",
		editCompanys_75: "会员代码位数",
		editCompanys_76: "系统错误",
		editCompanys_77: "邀请失败",
		editCompanys_78: "邀请成功",
		editCompanys_79: "邀请店铺：",
		editCompanys_80: "邀请店铺",
		editCompanys_81: "邀请店铺加入会社",
		editCompanys_82: "店铺人员邮箱：",
		editCompanys_83: "发送邀请",
		editCompanys_84: "请输入邮箱",
		editCompanys_85: "邮箱格式不正确",
		editCompanys_86: "只能输入英文字母"
	},
	companysDetails: {
		companysDetails_0: "会社管理",
		companysDetails_1: "会社详情",
		companysDetails_2: "会社ID：",
		companysDetails_3: "请输入会社ID",
		companysDetails_4: "会社名称：",
		companysDetails_5: "请输入会社名称",
		companysDetails_6: "拼音：",
		companysDetails_7: "请输入拼音",
		companysDetails_8: "会社種類(前)：",
		companysDetails_9: "请选择会社種類(前)",
		companysDetails_10: "会社種類(後)：",
		companysDetails_11: "请选择会社種類(後)",
		companysDetails_12: "郵便番号：",
		companysDetails_13: "请输入郵便番号",
		companysDetails_14: "電話：",
		companysDetails_15: "请输入電話",
		companysDetails_16: "都道府県：",
		companysDetails_17: "请选择都道府県",
		companysDetails_18: "住所：",
		companysDetails_19: "请输入住所",
		companysDetails_20: "传真：",
		companysDetails_21: "请输入传真",
		companysDetails_22: "网站：",
		companysDetails_23: "请输入网站",
		companysDetails_24: "代表者名：",
		companysDetails_25: "请输入代表者名",
		companysDetails_26: "代表者名(拼音)：",
		companysDetails_27: "请输入代表者名(拼音)",
		companysDetails_28: "信用卡绑定：",
		companysDetails_29: "绑定信用卡信息",
		companysDetails_30: "信用卡未绑定！",
		companysDetails_31: "返回",
		companysDetails_32: "信用卡绑定详情",
		companysDetails_33: "カード番号：",
		companysDetails_34: "TOKEN：",
		companysDetails_35: "有効期限：",
		// companysDetails_36:"カード会員名（名）：",
		// companysDetails_37:"カード会員名（姓）：",
		// companysDetails_38:"メールアドレス：",
		// companysDetails_39:"電話番号：",
		companysDetails_40: "长度在1-50之间",
		companysDetails_41: "只能输入数字以及横线",
		companysDetails_42: "请输入社名称",
		companysDetails_43: "请求失败",
		companysDetails_44: "无数据",
		companysDetails_45: "邀请失败",
		companysDetails_46: "邀请成功",
		companysDetails_47: "邀请店铺：",
		companysDetails_48: "邀请店铺",
		companysDetails_49: "邀请店铺加入会社",
		companysDetails_50: "店铺人员邮箱：",
		companysDetails_51: "发送邀请",
		companysDetails_52: "请输入邮箱",
		companysDetails_53: "邮箱格式不正确"
	},
	addGuide: {
				addGuide_0: "导游管理",
				addGuide_1: "导游新增",
				addGuide_2: "头像:",
				addGuide_3: "邮箱号:",
				addGuide_4: "请输入邮箱号",
				addGuide_5: "密码:",
				addGuide_6: "请设置初始密码",
				addGuide_7: "昵称:",
				addGuide_8: "请输入昵称",
				addGuide_9: "携帯電話:",
				addGuide_10: "请输入手机号",
				addGuide_11: "电话番号:",
				addGuide_12: "请输入电话番号",
				addGuide_13: "性别:",
				addGuide_14: "男",
				addGuide_15: "女",
				addGuide_16: "积分:",
				addGuide_17: "实名认证:",
				addGuide_18: "上传实名认证",
				addGuide_19: "审核状态:",
				addGuide_20: "请选择审核状态",
				addGuide_21: "未认证",
				addGuide_22: "审核中",
				addGuide_23: "审核已通过",
				addGuide_24: "审核未通过",
				addGuide_25: "停用",
				addGuide_26: "实名认证基本信息",
				addGuide_27: "姓名:",
				addGuide_28: "请输入姓名",
				addGuide_29: "拼音:",
				addGuide_30: "请输入拼音",
				addGuide_31: "邮编番号:",
				addGuide_32: "请输入邮编番号",
				addGuide_33: "生年月日:",
				addGuide_34: "选择日期",
				addGuide_35: "都道府县:",
				addGuide_36: "住所:",
				addGuide_37: "证件种类:",
				addGuide_38: "注：氏名、住所および生年月日の記載があり、かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
				addGuide_39: "身份证书番号:",
				addGuide_40: "请输入身份证书番号",
				addGuide_41: "证件图片:",
				addGuide_42: "点击上传",
				addGuide_43: "证件正面",
				addGuide_44: "证件反面",
				addGuide_45: "返回",
				addGuide_46: "保存",
				addGuide_47: "返回",
				addGuide_48: "提交",
				addGuide_49: "长度在1-50之间",
				addGuide_50: "请输入正确手机格式",
				addGuide_51: "邮箱格式不正确",
				addGuide_52: "姓名不能为空",
				addGuide_53: "拼音不能为空",
				addGuide_54: "邮编番号不能为空",
				addGuide_55: "生年月日不能为空",
				addGuide_56: "都道府县不能为空",
				addGuide_57: "生年月日不能为空",
				addGuide_58: "证件种类不能为空",
				addGuide_59: "身份证书番号不能为空",
				addGuide_60: "上传头像图片只能是 JPG 格式!",
				addGuide_61: "上传头像图片大小不能超过 2MB!",
				addGuide_62: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
				addGuide_63: "邮箱不能重复注册",
				addGuide_64: "导游新增失败",
				addGuide_65: "导游新增成功",
				addGuide_66: "请求失败",
				addGuide_67: "表单验证失败",
				addGuide_68: "电话番号不可超过20个字符",
				addGuide_69: "携帯電話不可超过20个字符",
				addGuide_70: "住所不能为空",
				addGuide_71: "请输入住所",
				addGuide_72: "请输入6-18位密码",
				addGuide_73: "密码不能为空",
				addGuide_74: "证件正面照不能为空",
				addGuide_75: "证件反面照不能为空",
		addGuide_76: "身份证书番号格式不对",
		addGuide_77: "请选择都道府县",
		addGuide_78: "氏名、住所および生年月日の記載があり、 かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
		addGuide_79: "Passport",
		addGuide_80: "健康保険、国民健康保険または船員保険等",
		
			},
		
		
			editguide: {
				editguide_0: "导游管理",
				editguide_1: "导游编辑",
				editguide_2: "头像:",
				editguide_3: "邮箱号:",
				editguide_4: "请输入邮箱号",
				editguide_5: "密码:",
				editguide_6: "请设置初始密码",
				editguide_7: "昵称:",
				editguide_8: "请输入昵称",
				editguide_9: "携帯電話:",
				editguide_10: "请输入手机号",
				editguide_11: "电话番号:",
				editguide_12: "请输入电话番号",
				editguide_13: "性别:",
				editguide_14: "男",
				editguide_15: "女",
				editguide_16: "积分:",
				editguide_17: "实名认证:",
				editguide_18: "编辑认证详情",
				editguide_19: "审核状态:",
				editguide_20: "请选择审核状态",
				editguide_21: "未认证",
				editguide_22: "审核中",
				editguide_23: "审核已通过",
				editguide_24: "审核未通过",
				editguide_25: "停用",
				editguide_26: "实名认证基本信息",
				editguide_27: "姓名:",
				editguide_28: "请输入姓名",
				editguide_29: "拼音:",
				editguide_30: "请输入拼音",
				editguide_31: "邮编番号:",
				editguide_32: "请输入邮编番号",
				editguide_33: "生年月日:",
				editguide_34: "选择日期",
				editguide_35: "都道府县:",
				editguide_36: "住所:",
				editguide_37: "证件种类:",
				editguide_38: "注：氏名、住所および生年月日の記載があり、かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
				editguide_39: "身份证书番号:",
				editguide_40: "请输入身份证书番号",
				editguide_41: "证件图片:",
				editguide_42: "点击上传",
				editguide_43: "证件正面",
				editguide_44: "证件反面",
				editguide_45: "返回",
				editguide_46: "保存",
				editguide_47: "返回",
				editguide_48: "提交",
				editguide_49: "长度在1-50之间",
				editguide_50: "请输入正确手机格式",
				editguide_51: "邮箱格式不正确",
				editguide_52: "姓名不能为空",
				editguide_53: "拼音不能为空",
				editguide_54: "邮编番号不能为空",
				editguide_55: "生年月日不能为空",
				editguide_56: "都道府县不能为空",
				editguide_57: "生年月日不能为空",
				editguide_58: "证件种类不能为空",
				editguide_59: "身份证书番号不能为空",
				editguide_60: "上传头像图片只能是 JPG 格式!",
				editguide_61: "上传头像图片大小不能超过 2MB!",
				editguide_62: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
				editguide_63: "邮箱不能重复注册",
				editguide_64: "导游编辑失败",
				editguide_65: "导游编辑成功",
				editguide_66: "请求失败",
				editguide_67: "表单验证失败",
				editguide_68: "无数据",
				editguide_69: "请输入住所",
				editguide_70: "请输入6-18位密码",
				editguide_71: "请选择都道府县",
				editguide_72: "请选择证件种类",
				editguide_73: "请输入积分",
				editguide_74: "证件正面照不能为空",
				editguide_75: "证件反面照不能为空",
				editguide_76: "住所不能为空",
		editguide_77: "氏名、住所および生年月日の記載があり、 かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
		editguide_78: "Passport",
		editguide_79: "健康保険、国民健康保険または船員保険等",
		
		
			},
			guideDetails: {
				guideDetails_0: "导游管理",
				guideDetails_1: "导游查看",
				guideDetails_2: "头像:",
				guideDetails_3: "邮箱号:",
				guideDetails_4: "请输入邮箱号",
				guideDetails_5: "密码:",
				guideDetails_6: "请设置初始密码",
				guideDetails_7: "昵称:",
				guideDetails_8: "请输入昵称",
				guideDetails_9: "携帯電話:",
				guideDetails_10: "请输入手机号",
				guideDetails_11: "电话番号:",
				guideDetails_12: "请输入电话番号",
				guideDetails_13: "性别:",
				guideDetails_14: "男",
				guideDetails_15: "女",
				guideDetails_16: "积分:",
				guideDetails_17: "实名认证:",
				guideDetails_18: "查看认证详情",
				guideDetails_19: "审核状态:",
				guideDetails_20: "请选择审核状态",
				guideDetails_21: "未认证",
				guideDetails_22: "审核中",
				guideDetails_23: "审核已通过",
				guideDetails_24: "审核未通过",
				guideDetails_25: "停用",
				guideDetails_26: "实名认证基本信息",
				guideDetails_27: "姓名:",
				guideDetails_28: "请输入姓名",
				guideDetails_29: "拼音:",
				guideDetails_30: "请输入拼音",
				guideDetails_31: "邮编番号:",
				guideDetails_32: "请输入邮编番号",
				guideDetails_33: "生年月日:",
				guideDetails_34: "选择日期",
				guideDetails_35: "都道府县:",
				guideDetails_36: "住所:",
				guideDetails_37: "证件种类:",
				guideDetails_38: "注：氏名、住所および生年月日の記載があり、かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
				guideDetails_39: "身份证书番号:",
				guideDetails_40: "请输入身份证书番号",
				guideDetails_41: "证件图片:",
				guideDetails_42: "点击上传",
				guideDetails_43: "证件正面",
				guideDetails_44: "证件反面",
				guideDetails_45: "返回",
				guideDetails_46: "保存",
				guideDetails_47: "返回",
				guideDetails_48: "提交",
				guideDetails_49: "长度在1-50之间",
				guideDetails_50: "请输入正确手机格式",
				guideDetails_51: "邮箱格式不正确",
				guideDetails_52: "姓名不能为空",
				guideDetails_53: "拼音不能为空",
				guideDetails_54: "邮编番号不能为空",
				guideDetails_55: "生年月日不能为空",
				guideDetails_56: "都道府县不能为空",
				guideDetails_57: "生年月日不能为空",
				guideDetails_58: "证件种类不能为空",
				guideDetails_59: "身份证书番号不能为空",
				guideDetails_60: "上传头像图片只能是 JPG 格式!",
				guideDetails_61: "上传头像图片大小不能超过 2MB!",
				guideDetails_62: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
				guideDetails_63: "邮箱不能重复注册",
				guideDetails_64: "导游新增失败",
				guideDetails_65: "导游新增成功",
				guideDetails_66: "请求失败",
				guideDetails_67: "表单验证失败",
				
				guideDetails_68: "氏名、住所および生年月日の記載があり、 かつ、郵便物・荷物を受け取る際に有効なものに限ります。",
				guideDetails_69: "Passport",
				guideDetails_70: "健康保険、国民健康保険または船員保険等",
				
		
			},
			guideList: {
				guideList_0: "导游管理",
				guideList_1: "无数据",
				guideList_2: "请求失败",
				guideList_3: "导游编辑",
				guideList_4: "导游编辑失败",
				guideList_5: "导游编辑成功",
				guideList_6: "导游查看",
				guideList_7: "请选择审核状态",
				guideList_8: "请搜索导游ID/昵称/邮箱/电话",
				guideList_9: "   开始日期",
				guideList_10: "    结束日期",
				guideList_11: "搜索",
				guideList_12: "批量删除",
				guideList_13: "导出Excel",
				guideList_14: "导游ID",
				guideList_15: "邮箱",
				guideList_16: "电话",
				guideList_17: "导游积分",
				guideList_18: "操作",
				guideList_19: "查看",
				guideList_20: "编辑",
				guideList_21: "删除",
				guideList_22: "您确定要删除吗？",
				guideList_23: "提示",
				guideList_24: "删除失败",
				guideList_25: "删除成功",
				guideList_26: "取消",
				guideList_27: "您确定要批量删除吗？",
				guideList_28: "批量删除成功",
				guideList_29: "请您在列表中勾选您要删除的导游信息",
				guideList_30: "此操作将导出excel文件, 是否继续?",
				guideList_31: "昵称",
				guideList_32: "新增时间",
				guideList_33: "请选择要导出的列表",
				guideList_34: "导游列表",
				guideList_35: "ID",
				guideList_36: "角色",
				guideList_37: "所属店铺",
				guideList_38: "所属代理商",
				guideList_39: "导入中，请稍候...",
			
				guideList_40: "导游列表",
				guideList_41: "新增",
				guideList_42: "审核状态",
				guideList_43: "确定",
				guideList_44: "已审核",
				guideList_45: "待审核",
				guideList_46: "未认证",
				guideList_47: "审核中",
				guideList_48: "审核已通过",
				guideList_49: "审核未通过",
				guideList_50: "停用",
				guideList_51: "删除状态",
				
				guideList_52: "正常",
				guideList_53: "删除",
				guideList_54: "恢复",
				guideList_55: "您确定要恢复吗？",
				guideList_56: "恢复成功",
				guideList_57: "恢复失败",
			
			},
			
		
	
		
		
	
	addAgent: {
		addAgent_0: "代理商管理",
		addAgent_1: "新增代理商",
		addAgent_2: "代理商名称：",
		addAgent_3: "请输入代理商名称",
		addAgent_4: "代理商名称不能为空",
		addAgent_5: "ふりがな：",
		addAgent_6: "请输入ふりがな：",
		addAgent_7: "業種：",
		addAgent_8: "请输入業種",
		addAgent_9: "会社種類(前)：",
		addAgent_10: "请输入会社種類(前)",
		addAgent_11: "会社種類(後)：",
		addAgent_12: "请输入会社種類(後)",
		addAgent_13: "法人番号：",
		addAgent_14: "请输入法人番号",
		addAgent_15: "郵便番号：",
		addAgent_16: "请输入郵便番号",
		addAgent_17: "都道府県：",
		addAgent_18: "请输入都道府県",
		addAgent_19: "住所：",
		addAgent_20: "请输入住所",
		addAgent_21: "電話：",
		addAgent_22: "请输入電話",
		addAgent_23: "FAX：",
		addAgent_24: "请输入FAX",
		addAgent_25: "URL：",
		addAgent_26: "请输入URL",
		addAgent_27: "可用积分：",
		addAgent_28: "请输入可用积分",
		addAgent_29: "代表者基本信息",
		addAgent_30: "代表者名：",
		addAgent_31: "请输入代表者名",
		addAgent_32: "代表者名かな：",
		addAgent_33: "请输入代表者名かな",
		addAgent_34: "生  年  月  日 ：（代表取締役）",
		addAgent_35: "请输入生日",
		addAgent_36: "身分証明書番号：（代表取締役）",
		addAgent_37: "请输入身分証明書番号",
		addAgent_38: "身分証明書写真：（代表取締役）",
		addAgent_39: "电  话  番  号 ：（代表取締役）",
		addAgent_40: "请输入電話番号",
		addAgent_41: "担当者基本信息",
		addAgent_42: "氏名：",
		addAgent_43: "请输入氏名",
		addAgent_44: "電話番号：",
		addAgent_45: "请输入電話番号",
		addAgent_46: "メールアドレス：",
		addAgent_47: "请输入メールアドレス",
		addAgent_48: "返回",
		addAgent_49: "提交",
		addAgent_50: "请输入メールアドレス号",
		addAgent_51: "メールアドレス格式不正确",
		addAgent_52: "メールアドレス不能为空",
		addAgent_53: "请求失败",
		addAgent_54: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		addAgent_55: "上传头像图片大小不能超过 2MB!",
		addAgent_56: "邮箱不能重复注册",
		addAgent_57: "代理商新增失败",
		addAgent_58: "代理商新增成功",
		addAgent_59: "请求失败",
		addAgent_60: "表单验证失败",
		addAgent_61: "代理商基本信息",
		addAgent_62: "メールアドレス不能为空",
		addAgent_63: "メールアドレス格式不正确",

	},

	AgentList: {
		AgentList_0: "代理商管理",
		AgentList_1: "可搜索代理商ID/代理商名称/代表者名",
		AgentList_2: "请搜索代理商ID",
		AgentList_3: "请搜索可用积分",
		AgentList_4: "开始日期",
		AgentList_5: "结束日期",
		AgentList_6: "搜索",
		AgentList_7: "批量删除",
		AgentList_8: "导出Excel",
		AgentList_9: "新增",
		AgentList_10: "代理商ID",
		AgentList_11: "代理商名称",
		AgentList_12: "代表者名",
		AgentList_13: "用户数量",
		AgentList_14: "店铺数量",
		AgentList_15: "导游数量",
		AgentList_16: "可用积分",
		AgentList_17: "操作",
		AgentList_18: "查看",
		AgentList_19: "编辑",
		AgentList_20: "删除",
		AgentList_21: "请求失败",
		AgentList_22: "您确定要删除吗？",
		AgentList_23: "提示",
		AgentList_24: "删除失败",
		AgentList_25: "删除成功",
		AgentList_26: "取消",
		AgentList_27: "您确定要批量删除吗？",
		AgentList_28: "批量删除成功",
		AgentList_29: "请您在列表中勾选您要删除的代理商信息",
		AgentList_30: "此操作将导出excel文件, 是否继续?",
		AgentList_31: "确定",
		AgentList_32: "取消",
		AgentList_33: "代理商列表",
		AgentList_34: "请选择要导出的列表",
		AgentList_35: "导入中，请稍候..."
	},
	AgentDetails: {
		AgentDetails_0: "代理商管理",
		AgentDetails_1: "查看代理商",
		AgentDetails_2: "代理商名称：",
		AgentDetails_3: "请输入代理商名称",
		AgentDetails_4: "(ふりがな)：",
		AgentDetails_5: "请输入(ふりがな)",
		AgentDetails_6: "業種：",
		AgentDetails_7: "请输入業種",
		AgentDetails_8: "会社種類(前)",
		AgentDetails_9: "请输入会社種類(前)：",
		AgentDetails_10: "会社種類(後)：",
		AgentDetails_11: "请输入会社種類(後)",
		AgentDetails_12: "法人番号：",
		AgentDetails_13: "请输入法人番号",
		AgentDetails_14: "郵便番号：",
		AgentDetails_15: "请输入郵便番号",
		AgentDetails_16: "都道府県：",
		AgentDetails_17: "请输入都道府県",
		AgentDetails_18: "住所：",
		AgentDetails_19: "请输入住所",
		AgentDetails_20: "電話：",
		AgentDetails_21: "请输入電話",
		AgentDetails_22: "FAX：",
		AgentDetails_23: "请输入FAX",
		AgentDetails_24: "URL：",
		AgentDetails_25: "请输入URL",
		AgentDetails_26: "可用积分：",
		AgentDetails_27: "请输入可用积分",
		AgentDetails_28: "查看详情",
		AgentDetails_29: "提现",
		AgentDetails_30: "绑定银行卡：",
		AgentDetails_31: "请输入绑定银行卡",
		AgentDetails_32: "变更银行卡",
		AgentDetails_33: "店铺数量：",
		AgentDetails_34: "请输入店铺数量",
		AgentDetails_35: "添加店铺",
		AgentDetails_36: "导游数量：",
		AgentDetails_37: "添加导游",
		AgentDetails_38: "用户数量：",
		AgentDetails_39: "添加用户",
		AgentDetails_40: "代表者基本信息",
		AgentDetails_41: "代表者名：",
		AgentDetails_42: "请输入代表者名",
		AgentDetails_43: "代表者名かな：",
		AgentDetails_44: "请输入代表者名かな",
		AgentDetails_45: "生年月日：\n\t\r（代表取締役）",
		AgentDetails_46: "请输入生年月日",
		AgentDetails_47: "身分証明書番号：\n\t\r（代表取締役）",
		AgentDetails_48: "请输入身分証明書番号",
		AgentDetails_49: "身分証明書写真：\n\t\r（代表取締役）",
		AgentDetails_50: "電話番号\n\t\r（代表取締役）：",
		AgentDetails_51: "请输入電話番号",
		AgentDetails_52: "担当者基本信息",
		AgentDetails_53: "氏名：",
		AgentDetails_54: "请输入氏名",
		AgentDetails_55: "メールアドレス：",
		AgentDetails_56: "请输入メールアドレス",
		AgentDetails_57: "返回",
		AgentDetails_58: "提交",
		AgentDetails_59: "提现",
		AgentDetails_60: "提现积分：",
		AgentDetails_61: "请输入提现积分",
		AgentDetails_62: "银行卡号：",
		AgentDetails_63: "请输入银行卡号",
		AgentDetails_64: "口座名義(カタカナ)：",
		AgentDetails_65: "请输入口座名義(カタカナ)",
		AgentDetails_66: "口座名義：",
		AgentDetails_67: "请输入口座名義",
		AgentDetails_68: "确定",
		AgentDetails_69: "银行卡信息",
		AgentDetails_70: "银行名称：",
		AgentDetails_71: "请输入银行名称",
		AgentDetails_72: "金融機関コード：",
		AgentDetails_73: "请输入金融機関コード",
		AgentDetails_74: "支店名：",
		AgentDetails_75: "请输入支店名",
		AgentDetails_76: "支店コード：",
		AgentDetails_77: "请输入支店コード",
		AgentDetails_78: "口座種別：",
		AgentDetails_79: "请输入口座種別",
		AgentDetails_80: "口座名義(カタカナ)：",
		AgentDetails_81: "请输入口座名義(カタカナ)",
		AgentDetails_82: "口座名義：",
		AgentDetails_83: "请输入口座名義",
		AgentDetails_84: "口座番号：",
		AgentDetails_85: "请输入口座番号",
		AgentDetails_86: "请求失败",
		AgentDetails_87: "上传头像图片只能是 JPG 格式!",
		AgentDetails_88: "上传头像图片大小不能超过 2MB!",
		AgentDetails_89: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		AgentDetails_90: "请求失败",
		AgentDetails_91: "邮箱不能重复",
		AgentDetails_92: "银行卡变更失败",
		AgentDetails_93: "代理商修改成功",
		AgentDetails_94: "表单验证失败",
		AgentDetails_95: "電話番号：",
		AgentDetails_96: "代理商ID：",
		AgentDetails_97: "银行名称不能为空",
		AgentDetails_98: "金融機関コード不能为空",
		AgentDetails_99: "支店名不能为空",
		AgentDetails_100: "支店コード不能为空",
		AgentDetails_101: "口座種別不能为空",
		AgentDetails_102: "口座名義(カタカナ)不能为空",
		AgentDetails_103: "口座名義不能为空",
		AgentDetails_104: "口座番号不能为空",
		AgentDetails_107: "您未绑定银行卡,请绑定之后再提取积分", //52
		AgentDetails_108: "提示窗", //52
		AgentDetails_109: "去绑卡", //52
		AgentDetails_110: "注：提现金额不可大于当前可用积分数以及为0积分", //52
		AgentDetails_111: "代理商基本信息",
		AgentDetails_112: "银行卡修改成功",
		AgentDetails_113: "提现积分不能大于剩余积分",
		AgentDetails_114: "提现积分失败",
		AgentDetails_115: "提现积分成功",
		AgentDetails_116: "取消",

	},
	editAgent: {
		editAgent_0: "代理商管理",
		editAgent_1: "编辑代理商",
		editAgent_2: "代理商名称：",
		editAgent_3: "请输入代理商名称",
		editAgent_4: "(ふりがな)：",
		editAgent_5: "请输入(ふりがな)",
		editAgent_6: "業種：",
		editAgent_7: "请输入業種",
		editAgent_8: "会社種類(前)：",
		editAgent_9: "请输入会社種類(前)",
		editAgent_10: "会社種類(後)：",
		editAgent_11: "请输入会社種類(後)",
		editAgent_12: "法人番号：",
		editAgent_13: "请输入法人番号",
		editAgent_14: "郵便番号：",
		editAgent_15: "请输入郵便番号",
		editAgent_16: "都道府県：",
		editAgent_17: "请输入都道府県",
		editAgent_18: "住所：",
		editAgent_19: "请输入住所",
		editAgent_20: "電話：",
		editAgent_21: "请输入電話",
		editAgent_22: "FAX：",
		editAgent_23: "请输入FAX",
		editAgent_24: "URL：",
		editAgent_25: "请输入URL",
		editAgent_26: "可用积分：",
		editAgent_27: "请输入可用积分",
		editAgent_28: "查看详情",
		editAgent_29: "提现",
		editAgent_30: "绑定银行卡：",
		editAgent_31: "请输入绑定银行卡",
		editAgent_32: "变更银行卡",
		editAgent_33: "店铺数量：",
		editAgent_34: "请输入店铺数量",
		editAgent_35: "添加店铺",
		editAgent_36: "导游数量：",
		editAgent_37: "添加导游",
		editAgent_38: "用户数量：",
		editAgent_39: "添加用户",
		editAgent_40: "代表者基本信息",
		editAgent_41: "代表者名：",
		editAgent_42: "请输入代表者名",
		editAgent_43: "代表者名かな：",
		editAgent_44: "请输入代表者名かな",
		editAgent_45: "生年月日：（代表取締役）",
		editAgent_46: "请输入生年月日",
		editAgent_47: "身分証明書番号:代表取締役）",
		editAgent_48: "请输入身分証明書番号",
		editAgent_49: "身分証明書写真：（代表取締役）",
		editAgent_50: "電話番号：（代表取締役）",
		editAgent_51: "请输入電話番号",
		editAgent_52: "担当者基本信息",
		editAgent_53: "氏名：",
		editAgent_54: "请输入氏名",
		editAgent_55: "メールアドレス：",
		editAgent_56: "请输入メールアドレス",
		editAgent_57: "返回",
		editAgent_58: "保存",
		editAgent_59: "提现",
		editAgent_60: "提现积分：",
		editAgent_61: "请输入提现积分",
		editAgent_62: "银行卡号：",
		editAgent_63: "请输入银行卡号",
		editAgent_64: "口座名義(カタカナ)：",
		editAgent_65: "请输入口座名義(カタカナ)",
		editAgent_66: "口座名義：",
		editAgent_67: "请输入口座名義",
		editAgent_68: "确定",
		editAgent_69: "银行卡信息",
		editAgent_70: "银行名称：",
		editAgent_71: "请输入银行名称",
		editAgent_72: "金融機関コード：",
		editAgent_73: "请输入金融機関コード",
		editAgent_74: "支店名：",
		editAgent_75: "请输入支店名",
		editAgent_76: "支店コード：",
		editAgent_77: "请输入支店コード",
		editAgent_78: "口座種別：",
		editAgent_79: "请输入口座種別",
		editAgent_80: "口座名義(カタカナ)：",
		editAgent_81: "请输入口座名義(カタカナ)",
		editAgent_82: "口座名義：",
		editAgent_83: "请输入口座名義",
		editAgent_84: "口座番号：",
		editAgent_85: "请输入口座番号",
		editAgent_86: "请求失败",
		editAgent_87: "上传头像图片只能是 JPG 格式!",
		editAgent_88: "上传头像图片大小不能超过 2MB!",
		editAgent_89: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		editAgent_90: "请求失败",
		editAgent_91: "邮箱不能重复",
		editAgent_92: "银行卡变更失败",
		editAgent_93: "代理商修改成功",
		editAgent_94: "表单验证失败",
		editAgent_95: "電話番号：",
		editAgent_96: "代理商ID：",
		editAgent_97: "银行名称不能为空",
		editAgent_98: "金融機関コード不能为空",
		editAgent_99: "支店名不能为空",
		editAgent_100: "支店コード不能为空",
		editAgent_101: "口座種別不能为空",
		editAgent_102: "口座名義(カタカナ)不能为空",
		editAgent_103: "口座名義不能为空",
		editAgent_104: "口座番号不能为空",
		editAgent_105: "メールアドレス格式不正确", //51
		editAgent_106: "メールアドレス不能为空", //52
		editAgent_107: "您未绑定银行卡,请绑定之后再提取积分", //52
		editAgent_108: "提示窗", //52
		editAgent_109: "去绑卡", //52注：提现金额不可大于当前可用积分数以及为0积分
		editAgent_110: "注：提现金额不可大于当前可用积分数以及为0积分", //52
		editAgent_111: "代理商基本信息",
		editAgent_112: "银行卡修改成功",
		editAgent_113: "提现积分不能大于剩余积分",
		editAgent_114: "提现积分失败",
		editAgent_115: "提现积分成功",
		editAgent_116: "取消",
	},
	goodsList: {
		goodsList_0: "套餐管理",
		goodsList_1: "请搜索商品名称/店铺名称",
		goodsList_2: "请选择审核状态",
		goodsList_3: "商品状态",
		goodsList_4: "搜索",
		goodsList_5: "批量删除",
		goodsList_6: "导出Excel",
		goodsList_7: "新增",
		goodsList_8: "商品ID",
		goodsList_9: "商品名称",
		goodsList_10: "店铺名称",
		goodsList_11: "返点比例",
		goodsList_12: "审核状态",
		goodsList_13: "未认证",
		goodsList_14: "审核中",
		goodsList_15: "审核已通过",
		goodsList_16: "审核未通过",
		goodsList_17: "停用",
		goodsList_18: "商品状态",
		goodsList_19: "上架",
		goodsList_20: "下架",
		goodsList_21: "操作",
		goodsList_22: "查看",
		goodsList_23: "编辑",
		goodsList_24: "删除",
		goodsList_25: "グルメ",
		goodsList_26: "体験",
		goodsList_27: "宿泊",
		goodsList_28: "癒し",
		goodsList_29: "邮箱不能重复注册",
		goodsList_30: "套餐修改失败",
		goodsList_31: "套餐修改成功",
		goodsList_32: "修改状态成功",
		goodsList_33: "请求失败",
		goodsList_34: "您确定要删除吗？",
		goodsList_35: "提示",
		goodsList_36: "删除失败",
		goodsList_37: "删除成功",
	
		goodsList_38: "您确定要批量删除吗？",
	
		goodsList_39: "删除失败",
		goodsList_40: "批量删除成功",
		goodsList_41: "请您在列表中勾选您要删除的套餐信息",
		goodsList_42: "此操作将导出excel文件, 是否继续?",
		goodsList_43: "确定",
		goodsList_44: "取消",
		goodsList_45: "请选择要导出的列表",
		goodsList_46: "套餐列表",
		goodsList_47: "导入中，请稍候...",
		goodsList_48: "你确定要上架吗",
		goodsList_49: "你确定要下架吗",
		goodsList_50: "操作成功",
		goodsList_51: "操作失败",
		goodsList_52: "只有审核已通过的商品可以修改商品状态",
	
	},
	



	addgoods: {
		addgoods_0: "套餐管理",
		addgoods_1: "新增套餐",
		addgoods_2: "商品名称：",
		addgoods_3: "请输入商品名称",
		addgoods_4: "店铺名称：",
		addgoods_5: "请选择分类",
		addgoods_6: "使用人数：",
		addgoods_7: "请输入使用人数",
		addgoods_8: "返点比例：",
		addgoods_9: "人均：",
		addgoods_10: "日元",
		addgoods_11: "商品状态：",
		addgoods_12: "请选择分类",
		addgoods_13: "套餐详情：",
		addgoods_14: "请输入套餐详情",
		addgoods_15: "套餐图片：",
		addgoods_16: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过40k。",
		addgoods_17: "使用规则：",
		addgoods_18: "请输入使用规则",
		addgoods_19: "审核状态：",
		addgoods_20: "未认证",
		addgoods_21: "返回",
		addgoods_22: "保存",
		addgoods_23: "只能输入数字",
		addgoods_24: "上架",
		addgoods_25: "下架",
		addgoods_26: "グルメ",
		addgoods_27: "体験",
		addgoods_28: "宿泊",
		addgoods_29: "癒し",
		addgoods_30: "商品名称不能为空",
		addgoods_31: "商品名称不能超过50个字符",
		addgoods_32: "店铺名称不能为空",
		addgoods_33: "请填写大于0的数字",
		addgoods_34: "最多只能上传9图片",
		addgoods_35: "上传环境图片只能是 JPG/PNG/JPEG 格式!",
		addgoods_36: "上传环境图片大小不能超过 40kB!",
		addgoods_37: "请求失败",
		addgoods_38: "邮箱不能重复注册",
		addgoods_39: "套餐新增失败",
		addgoods_40: "套餐新增成功",
		addgoods_41: "表单验证失败",

		addgoods_42: "分类",
		addgoods_43: "请选择分类"

	},
	editgoods: {
		editgoods_0: "套餐管理",
		editgoods_1: "修改套餐",
		editgoods_2: "商品名称：",
		editgoods_3: "请输入商品名称",
		editgoods_4: "店铺名称：",
		editgoods_5: "请选择店铺名称",
		editgoods_6: "使用人数：",
		editgoods_7: "请输入使用人数",
		editgoods_8: "人",
		editgoods_9: "返点比例：",
		editgoods_10: "价格：",
		editgoods_11: "日元",
		editgoods_12: "商品状态：",
		editgoods_13: "请选择商品状态",
		editgoods_14: "套餐详情：",
		editgoods_15: "请输入套餐详情",
		editgoods_16: "套餐图片：",
		editgoods_17: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过40k。",
		editgoods_18: "使用规则：",
		editgoods_19: "请输入使用规则",
		editgoods_20: "审核状态：",
		editgoods_21: "请选择审核状态",
		editgoods_22: "返回",
		editgoods_23: "提交",
		editgoods_24: "商品名称不能为空",
		editgoods_25: "商品名称不可超过50字",
		editgoods_26: "上架",
		editgoods_27: "下架",
		editgoods_28: "グルメ",
		editgoods_29: "体験",
		editgoods_30: "宿泊",
		editgoods_31: "癒し",
		editgoods_32: "商品名称不能为空",
		editgoods_33: "商品名称不能超过50个字符",
		editgoods_34: "店铺名称不能为空",
		editgoods_35: "请填写大于0的数字",
		editgoods_36: "最多只能上传9图片",
		editgoods_37: "删除成功",
		editgoods_38: "请求失败",
		editgoods_39: "上传环境图片只能是 JPG/PNG/JPEG 格式!",
		editgoods_40: "上传环境图片大小不能超过 40kB!",
		editgoods_41: "邮箱不能重复注册",
		editgoods_42: "套餐修改失败",
		editgoods_43: "套餐修改成功",
		editgoods_44: "请求失败",
		editgoods_45: "表单验证失败",
		editgoods_46: "无数据",
		editgoods_47: "请输入返点比例",
		editgoods_48: "请输入价格",
		editgoods_49: "修改成功",
		editgoods_50: "商品ID",
		editgoods_51: "审核备注：",
		editgoods_52: "请输入审核备注",
		editgoods_53: "审核已通过",




	},
	goodsDetails: {
		goodsDetails_0: "套餐管理",
		goodsDetails_1: "查看套餐",
		goodsDetails_2: "商品名称：",
		goodsDetails_3: "请输入商品名称",
		goodsDetails_4: "店铺名称：",
		goodsDetails_5: "请输入店铺名称",
		goodsDetails_6: "使用人数：",
		goodsDetails_7: "请输入使用人数",
		goodsDetails_8: "人",
		goodsDetails_9: "返点比例：",
		goodsDetails_10: "人均：",
		goodsDetails_11: "日元",
		goodsDetails_12: "商品状态：",
		goodsDetails_13: "套餐详情：",
		goodsDetails_14: "套餐图片：",
		goodsDetails_15: "最多可以上传9张图片，PNG、jpg格式图片，建议尺寸在800px*600px，不可超过40k。",
		goodsDetails_16: "使用规则：",
		goodsDetails_17: "审核状态：",
		goodsDetails_18: "返回",
		goodsDetails_19: "商品名称不能为空",
		goodsDetails_20: "商品名称不可超过50字",
		goodsDetails_21: "上架",
		goodsDetails_22: "下架",
		goodsDetails_23: "グルメ",
		goodsDetails_24: "体験",
		goodsDetails_25: "宿泊",
		goodsDetails_26: "癒し",
		goodsDetails_27: "代理商名称不能为空",
		goodsDetails_28: "最多只能上传9图片",
		goodsDetails_29: "上传环境图片只能是 JPG/PNG/JPEG 格式!",
		goodsDetails_30: "上传环境图片大小不能超过 40kB!",
		goodsDetails_31: "商品名称不能为空",
		goodsDetails_32: "商品名称不可超过50字",
		goodsDetails_33: "请求失败",
		goodsDetails_34: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		goodsDetails_35: "上传头像图片大小不能超过 2MB!",
		goodsDetails_36: "无数据",
		goodsDetails_37: "商品ID",
		goodsDetails_38: "审核备注："
	},
	
	
	
	
	orderList: {
		orderList_0: "订单管理",
		orderList_1: "可搜索订单编号/导游名称/店铺名称",
		orderList_2: "订单状态",
		orderList_3: "开始日期",
		orderList_4: "结束日期",
		orderList_5: "搜索",
		orderList_6: "删除",
		orderList_7: "导出Excel",
		orderList_8: "预约ID",
		orderList_9: "导游名称",
		orderList_10: "订单编号",
		orderList_11: "店铺名称",
		orderList_12: "下单时间",
		orderList_13: "订单状态",
		orderList_14: "预约中",
		orderList_15: "已接单",
		orderList_16: "已进店",
		orderList_17: "结算未付款",
		orderList_18: "已完结",
		orderList_19: "取消",
		orderList_20: "查看",
		orderList_21: "删除",
		orderList_22: "请求失败",
		orderList_23: "您确定要删除吗？",
		orderList_24: "提示",
		orderList_25: "删除失败",
		orderList_26: "删除成功",
		orderList_27: "您确定要批量删除吗？",
		orderList_28: "批量删除成功",
		orderList_29: "请您在列表中勾选您要删除的导游信息",
		orderList_30: "此操作将导出excel文件, 是否继续?",
		orderList_31: "确定",
		orderList_32: "取消",
		orderList_33: "请选择要导出的列表",
		orderList_34: "订单列表",
		orderList_35: "导入中，请稍候...",
orderList_36: "操作",
	},


	integral: {
		integral_0: "代理商管理",
		integral_1: "序号",
		integral_2: "积分类型",
		integral_3: "申请人",
		integral_4: "剩余积分",
		integral_5: "积分变更",
		integral_6: "变更时间",
		integral_7: "请求失败",

},

orderDetails: {
		orderDetails_0: "订单管理：",
		orderDetails_1: "查看订单：",
		orderDetails_2: "预约信息：",
		orderDetails_3: "予約ID：",
		orderDetails_4: "订单状态：",
		orderDetails_5: "导游名称：",
		orderDetails_6: "電話：",
		orderDetails_7: "予約日期：",
		orderDetails_8: "予約时间：",
		orderDetails_9: "予約総人数：",
		orderDetails_10: "备注：",
		orderDetails_11: "店铺ID：",
		orderDetails_12: "查看详情",
		orderDetails_13: "店铺名称：",
		orderDetails_14: "会社ID：",
		orderDetails_15: "代理商ID：",
		orderDetails_16: "详细地址：",
		orderDetails_17: "电话：",
		orderDetails_18: "人均：",
		orderDetails_19: "提前取消时间",
		orderDetails_20: "预订套餐",
		orderDetails_21: "套餐名称：",
		orderDetails_22: "套餐ID：",
		orderDetails_23: "套餐返点数：",
		orderDetails_24: "套餐数：",
		orderDetails_25: "标签：",
		orderDetails_26: "订单信息",
		orderDetails_27: "下单时间：",
		orderDetails_28: "订单编号 ：",
		orderDetails_29: "进店时间：",
		orderDetails_30: "消费时间：",
		orderDetails_31: "消费金额：",
		orderDetails_32: "消费积分：",
		orderDetails_33: "账单小票：",
		orderDetails_34: "备注：",
		orderDetails_35: "返回",
		orderDetails_36: "预约中",
		orderDetails_37: "已接单",
		orderDetails_38: "已进店",
		orderDetails_39: "结算未付款",
		orderDetails_40: "已完结",
		orderDetails_41: "取消",
		orderDetails_42: "请求失败",

	},
	withdrawlist: {
		withdrawlist_0: "提现管理",
		withdrawlist_1: "请搜索姓名/邮箱号",
		withdrawlist_2: "提现状态",
		withdrawlist_3: "请求失败",
		withdrawlist_4: "搜索",
		withdrawlist_5: "序号",

		withdrawlist_6: "姓名",
		withdrawlist_7: "邮箱",
		withdrawlist_8: "提现身份",
		withdrawlist_9: "提现金额",
		withdrawlist_10: "提现状态",
		withdrawlist_11: "操作",
		withdrawlist_12: "查看",
		withdrawlist_13: "编辑",
		withdrawlist_14: "删除",
		withdrawlist_15: "导游",
		withdrawlist_16: "代理商",
		withdrawlist_17: "删除成功",
		withdrawlist_18: "删除失败",
		withdrawlist_19: "您确定要删除吗",
		withdrawlist_20: "提示",
		withdrawlist_21: "提现单号",

	},
	rolesList: {
		rolesList_0: "角色管理",
		rolesList_1: "请搜索角色名",
		rolesList_2: "开始日期",
		rolesList_3: "结束日期",
		rolesList_4: "搜索",
		rolesList_5: "新增",
		rolesList_6: "角色名",
		rolesList_7: "备注",
		rolesList_8: "创建人",
		rolesList_9: "创建时间",
		rolesList_10: "操作",
		rolesList_11: "编辑",
		rolesList_12: "删除",
		rolesList_13: "新增角色",
		rolesList_14: "编辑角色",
		rolesList_15: "返回",
		rolesList_16: "提交",
		rolesList_17: "拼命加载中",
		rolesList_18: "全选",
		rolesList_19: "重置",
		rolesList_20: "请输入角色名",
		rolesList_21: "请求失败",
		rolesList_22: "您确定要删除吗？",
		rolesList_23: "提示",
		rolesList_24: "删除失败",
		rolesList_25: "删除成功",
		rolesList_26: "确认提交吗？",
		rolesList_27: "角色名称不能重复新增",
		rolesList_28: "操作失败",
		rolesList_29: "操作成功",
		rolesList_30: "超级管理员拥有所有菜单权限，不允许修改！",
		rolesList_31: "目录",
		rolesList_32: "菜单",
		rolesList_33: "按钮",
		rolesList_34: "顶级菜单",
		rolesList_35: "角色菜单授权",
		rolesList_36: "角色名：",
		rolesList_37: "备注：",
		rolesList_38: "检索",
		rolesList_39: "角色管理",
		rolesList_40: "ID",
		rolesList_41: "删除。可以吗?",
		rolesList_42: "数据删除成功了。",
		rolesList_43: "数据删除失败了。",
		rolesList_44: "数据登录成功。",
		rolesList_45: "数据登录失败。",
		rolesList_46: "输入的角色名称已经存在。\n请再试一次。",
		rolesList_47: "登录数据。可以吗?",
		
	},
	menusList: {
		menusList_0: "菜单管理",
		menusList_1: "请搜索菜单名称",
		menusList_2: "搜索",
		menusList_3: "新增",
		menusList_4: "拼命加载中",
		menusList_5: "菜单名称",
		menusList_6: "图标",
		menusList_7: "类型",
		menusList_8: "目录",
		menusList_9: "菜单",
		menusList_10: "按钮",
		menusList_11: "上级菜单",
		menusList_12: "菜单URL",
		menusList_13: "授权标识",
		menusList_14: "排序",
		menusList_15: "操作",
		menusList_16: "编辑",
		menusList_17: "删除",
		menusList_18: "新增菜单",
		menusList_19: "编辑菜单",
		menusList_20: "菜单类型",
		menusList_21: "名称",
		menusList_22: "顶级菜单",
		menusList_23: "授权标识",
		menusList_24: "菜单路由",
		menusList_25: "URL格式：",
		menusList_26: "1.常规业务开发的功能URL，如用户管理，pages目录下页面路径为 /users/usersList, 此处填写 /users/usersList。",
		menusList_27: "2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。",
		menusList_28: "示例：用户管理：/users/usersList 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000",
		menusList_29: "排序编号",
		menusList_30: "菜单图标",
		menusList_31: "菜单图标名称（如：el-icon-s-home）",
		menusList_32: "返回",
		menusList_33: "确认",
		menusList_34: "名称不能为空",
		menusList_35: "请求失败",
		menusList_36: "您确定要删除吗？",
		menusList_37: "提示",
		menusList_38: "删除失败",
		menusList_39: "删除成功",
		menusList_40: "确认提交吗？",
		menusList_41: "菜单名称不能重复新增",
		menusList_42: "操作失败",
		menusList_43: "操作成功"
	},
	shopsOneCate: {
		shopsOneCate_0: "店铺类别管理",
		shopsOneCate_1: "一级分类",
		shopsOneCate_2: "请搜索分类名称",
		shopsOneCate_3: "请选择状态",
		shopsOneCate_4: "搜索",
		shopsOneCate_5: "批量删除",
		shopsOneCate_6: "新增",
		shopsOneCate_7: "一级分类ID",
		shopsOneCate_8: "分类名称",
		shopsOneCate_9: "二级种类",
		shopsOneCate_10: "商品数",
		shopsOneCate_11: "优先级",
		shopsOneCate_12: "状态",
		shopsOneCate_13: "停用",
		shopsOneCate_14: "启用",
		shopsOneCate_15: "操作",
		shopsOneCate_16: "编辑",
		shopsOneCate_17: "删除",
		shopsOneCate_18: "新增一级分类",
		shopsOneCate_19: "编辑一级分类",
		shopsOneCate_20: "分类名称:",
		shopsOneCate_21: "优先级:",
		shopsOneCate_22: "状态:",
		shopsOneCate_23: "返回",
		shopsOneCate_24: "提交",
		shopsOneCate_25: "请输入分类名称",
		shopsOneCate_26: "请输入优先级",
		shopsOneCate_27: "请求失败",
		shopsOneCate_28: "您确定要删除吗？",
		shopsOneCate_29: "提示",
		shopsOneCate_30: "删除失败",
		shopsOneCate_31: "删除成功",
		shopsOneCate_32: "批量删除成功",
		shopsOneCate_33: "请您在列表中勾选您要删除的一级分类信息",
		shopsOneCate_34: "确认提交吗？",
		shopsOneCate_35: "一级分类名称不能重复新增",
		shopsOneCate_36: "操作失败",
		shopsOneCate_37: "操作成功",
		shopsOneCate_38: "请输入一级分类ID",
		shopsOneCate_39: "请输入正整数",
		shopsOneCate_40: "您确定要启用状态吗?",
		shopsOneCate_41: "您确定要停用状态吗?",
		shopsOneCate_42: "确定",
		shopsOneCate_43: "取消"

	},
	shopsTwoCate: {
		shopsTwoCate_0: "店铺类别管理",
		shopsTwoCate_1: "二级分类",
		shopsTwoCate_2: "请搜索分类名称",
		shopsTwoCate_3: "请选择状态",
		shopsTwoCate_4: "搜索",
		shopsTwoCate_5: "批量删除",
		shopsTwoCate_6: "新增",
		shopsTwoCate_7: "二级分类ID",
		shopsTwoCate_8: "分类名称",
		shopsTwoCate_9: "所属分类",
		shopsTwoCate_10: "商品数",
		shopsTwoCate_11: "优先级",
		shopsTwoCate_12: "状态",
		shopsTwoCate_13: "停用",
		shopsTwoCate_14: "启用",
		shopsTwoCate_15: "操作",
		shopsTwoCate_16: "编辑",
		shopsTwoCate_17: "删除",
		shopsTwoCate_18: "新增二级分类",
		shopsTwoCate_19: "编辑二级分类",
		shopsTwoCate_20: "分类名称:",
		shopsTwoCate_21: "所属分类:",
		shopsTwoCate_22: "请选择",
		shopsTwoCate_23: "优先级:",
		shopsTwoCate_24: "状态:",
		shopsTwoCate_25: "返回",
		shopsTwoCate_26: "提交",
		shopsTwoCate_27: "请输入分类名称",
		shopsTwoCate_28: "请选择所属分类",
		shopsTwoCate_29: "请输入优先级",
		shopsTwoCate_30: "请求失败",
		shopsTwoCate_31: "您确定要删除吗？",
		shopsTwoCate_32: "提示",
		shopsTwoCate_33: "删除失败",
		shopsTwoCate_34: "删除成功",
		shopsTwoCate_35: "批量删除成功",
		shopsTwoCate_36: "请您在列表中勾选您要删除的二级分类信息",
		shopsTwoCate_37: "确认提交吗？",
		shopsTwoCate_38: "二级分类名称不能重复新增",
		shopsTwoCate_39: "操作失败",
		shopsTwoCate_40: "操作成功",
		shopsTwoCate_41: "请输入二级分类ID",
		shopsTwoCate_42: "请输入正整数",
		shopsTwoCate_43: "您确定要启用状态吗?",
		shopsTwoCate_44: "您确定要停用状态吗?",
		shopsTwoCate_45: "确定",
		shopsTwoCate_46: "取消"
	},
	withdrawDetails: {
		withdrawDetails_0: "提现管理",
		withdrawDetails_1: "查看",
		withdrawDetails_2: "返回",
		withdrawDetails_3: "姓名:",
		withdrawDetails_4: "申请时间:",
		withdrawDetails_5: "邮箱号:",
		withdrawDetails_6: "电话号:",
		withdrawDetails_7: "提现状态:",
		withdrawDetails_8: "处理时间:",
		withdrawDetails_9: "银行卡名称:",
		withdrawDetails_10: "金融機関コード:",
		withdrawDetails_11: "支店名:",
		withdrawDetails_12: "支店コード:",
		withdrawDetails_13: "口座種別:",
		withdrawDetails_14: "口座番号:",
		withdrawDetails_15: "口座名義(カタカナ):",
		withdrawDetails_16: "口座名義:",
		withdrawDetails_17: "无数据",
		withdrawDetails_18: "请求失败",
		withdrawDetails_19: "请输入姓名",
		withdrawDetails_20: "请输入申请时间",
		withdrawDetails_21: "请输入邮箱号",
		withdrawDetails_22: "请输入电话号",
		withdrawDetails_23: "请输入处理时间",
		withdrawDetails_24: "请输入银行卡名称",
		withdrawDetails_25: "请输入金融機関コード",
		withdrawDetails_26: "请输入支店名",
		withdrawDetails_27: "请输入支店コード",
		withdrawDetails_28: "请输入口座種別",
		withdrawDetails_29: "请输入口座番号",
		withdrawDetails_30: "请输入口座名義(カタカナ)",
		withdrawDetails_31: "请输入口座名義",


	},
	withdrawEdit: {
		withdrawEdit_0: "提现管理",
		withdrawEdit_1: "编辑",
		withdrawEdit_2: "返回",
		withdrawEdit_3: "姓名:",
		withdrawEdit_4: "申请时间:",
		withdrawEdit_5: "邮箱号:",
		withdrawEdit_6: "电话号:",
		withdrawEdit_7: "提现状态:",
		withdrawEdit_8: "处理时间:",
		withdrawEdit_9: "银行卡名称:",
		withdrawEdit_10: "金融機関コード:",
		withdrawEdit_11: "支店名:",
		withdrawEdit_12: "支店コード:",
		withdrawEdit_13: "口座種別:",
		withdrawEdit_14: "口座番号:",
		withdrawEdit_15: "口座名義(カタカナ):",
		withdrawEdit_16: "口座名義:",
		withdrawEdit_17: "无数据",
		withdrawEdit_18: "请求失败",
		withdrawEdit_19: "确定",
		withdrawEdit_20: "请选择提现状态",
		withdrawEdit_21: "编辑成功",
		withdrawEdit_22: "编辑失败",
		withdrawEdit_23: "表单验证失败",
		withdrawEdit_24: "请输入名字",
		withdrawEdit_25: "请输入申请时间",
		withdrawEdit_26: "请输入邮箱",
		withdrawEdit_27: "请输入电话",
		withdrawEdit_28: "请输入处理时间",
		withdrawEdit_29: "请输入银行卡名称",
		withdrawEdit_30: "请输入金融機関コード",
		withdrawEdit_31: "请输入支店名",
		withdrawEdit_32: "请输入支店コード",
		withdrawEdit_33: "请输入口座種別",
		withdrawEdit_34: "请输入口座番号",
		withdrawEdit_35: "请输入口座名義(カタカナ)",
		withdrawEdit_36: "请输入口座名義",
	},
	MsgpushList: {
		MsgpushList_0: "消息推送管理",
		MsgpushList_1: "请搜索消息标题",
		MsgpushList_2: "请选择消息类型",
		MsgpushList_3: "请选择接收对象",
		MsgpushList_4: "开始日期",
		MsgpushList_5: "结束日期",
		MsgpushList_6: "搜索",
		MsgpushList_7: "批量删除",
		MsgpushList_8: "发送消息",
		MsgpushList_9: "序号",
		MsgpushList_10: "消息标题",
		MsgpushList_11: "发布人员",
		MsgpushList_12: "消息类别",
		MsgpushList_13: "接收对象",
		MsgpushList_14: "发布时间",
		MsgpushList_15: "操作",
		MsgpushList_16: "查看",
		MsgpushList_17: "删除",
		MsgpushList_18: "请求失败",
		MsgpushList_19: "您确定删除吗",
		MsgpushList_20: "提示",
		MsgpushList_21: "删除成功",
		MsgpushList_22: "删除失败",
		MsgpushList_23: "批量删除成功",
		MsgpushList_24: "请您在列表中勾选您要删除的推送信息",
		MsgpushList_25: "返回",
		MsgpushList_26: "禁用",
		MsgpushList_27: "发送",
		MsgpushList_28: "全部",
		MsgpushList_29: "店铺",
		MsgpushList_30: "导游",
		MsgpushList_31: "代理商",
		MsgpushList_32: "推送消息",
		MsgpushList_33: "取消"
	},
	MsgpushDetails: {
		MsgpushDetails_0: "查看消息",
		MsgpushDetails_1: "消息标题:",
		MsgpushDetails_2: "消息类别:",
		MsgpushDetails_3: "接收对象:",
		MsgpushDetails_4: "消息内容:",
		MsgpushDetails_5: "请输入消息标题",
		MsgpushDetails_6: "请选择消息类别",
		MsgpushDetails_7: "请选择接收对象",
		MsgpushDetails_8: "请输入消息内容",
	},
	MsgpushAdd: {
		MsgpushAdd_0: "发送消息",
		MsgpushAdd_1: "消息标题:",
		MsgpushAdd_2: "消息类别:",
		MsgpushAdd_3: "接收对象:",
		MsgpushAdd_4: "消息内容:",
		MsgpushAdd_5: "请输入消息标题",
		MsgpushAdd_6: "请选择消息类别",
		MsgpushAdd_7: "请选择接收对象",
		MsgpushAdd_8: "请输入消息内容",
		MsgpushAdd_9: "消息标题不能为空",
		MsgpushAdd_10: "消息类别不能为空",
		MsgpushAdd_11: "接收对象不能为空",
		MsgpushAdd_12: "消息内容不能为空",
		
		MsgpushAdd_13: "发送成功",
		MsgpushAdd_14: "发送失败",
		MsgpushAdd_15: "请求失败",
		MsgpushAdd_16: "表单验证失败",
		
	},
	synthesizeList: {
		synthesizeList_0: "首页店铺设置",
		synthesizeList_1: "综合推荐",
		synthesizeList_2: "搜索店铺名称/店铺ID",
		//synthesizeList_3: "搜索店铺ID",
		synthesizeList_4: "请选择状态",
		synthesizeList_5: "搜索",
		synthesizeList_6: "批量删除",
		synthesizeList_7: "新增",
		synthesizeList_8: "序号",
		synthesizeList_9: "会社ID",
		synthesizeList_10: "店铺ID",
		synthesizeList_11: "店铺名称",
		synthesizeList_12: "排序",
		synthesizeList_13: "是否推荐",
		synthesizeList_14: "状态",
		synthesizeList_15: "未推荐",
		synthesizeList_16: "推荐中",
		synthesizeList_17: "操作",
		synthesizeList_18: "编辑",
		synthesizeList_19: "删除",
		synthesizeList_20: "会社ID:",
		synthesizeList_21: "店铺ID:",
		synthesizeList_22: "店铺名称:",
		synthesizeList_23: "排序:",
		synthesizeList_24: "是否推荐:",
		synthesizeList_25: "返回",
		synthesizeList_26: "确定",
		synthesizeList_27: "请输入会社ID",
		synthesizeList_28: "请输入店铺ID",
		synthesizeList_29: "请输入店铺名称",
		synthesizeList_30: "请输入排序",
		synthesizeList_31: "请求失败",
		synthesizeList_32: "您确定要删除吗？",
		synthesizeList_33: "提示",
		synthesizeList_34: "删除失败",
		synthesizeList_35: "删除成功",
		synthesizeList_36: "批量删除成功",
		synthesizeList_37: "请您在列表中勾选您要删除的综合推荐信息",
		synthesizeList_38: "确认提交吗？",
		synthesizeList_39: "操作成功",
		synthesizeList_40: "操作失败",
		synthesizeList_41: "您确定要开启推荐状态吗?",
		synthesizeList_42: "您确定要关闭推荐状态吗?",
		synthesizeList_43: "确定",
		synthesizeList_44: "取消"
	},
	newlyList: {
		newlyList_0: "首页店铺设置",
		newlyList_1: "新店",
		newlyList_2: "搜索店铺名称/店铺ID",
		//newlyList_3: "搜索店铺ID",
		newlyList_4: "请选择状态",
		newlyList_5: "搜索",
		newlyList_6: "批量删除",
		newlyList_7: "新增",
		newlyList_8: "序号",
		newlyList_9: "会社ID",
		newlyList_10: "店铺ID",
		newlyList_11: "店铺名称",
		newlyList_12: "排序",
		newlyList_13: "是否推荐",
		newlyList_14: "状态",
		newlyList_15: "未推荐",
		newlyList_16: "推荐中",
		newlyList_17: "操作",
		newlyList_18: "编辑",
		newlyList_19: "删除",
		newlyList_20: "会社ID:",
		newlyList_21: "店铺ID:",
		newlyList_22: "店铺名称:",
		newlyList_23: "排序:",
		newlyList_24: "是否推荐:",
		newlyList_25: "返回",
		newlyList_26: "确定",
		newlyList_27: "请输入会社ID",
		newlyList_28: "请输入店铺ID",
		newlyList_29: "请输入店铺名称",
		newlyList_30: "请输入排序",
		newlyList_31: "请求失败",
		newlyList_32: "您确定要删除吗？",
		newlyList_33: "提示",
		newlyList_34: "删除失败",
		newlyList_35: "删除成功",
		newlyList_36: "批量删除成功",
		newlyList_37: "请您在列表中勾选您要删除的新店信息",
		newlyList_38: "确认提交吗？",
		newlyList_39: "操作成功",
		newlyList_40: "操作失败",
		newlyList_41: "您确定要开启推荐状态吗?",
		newlyList_42: "您确定要关闭推荐状态吗?",
		newlyList_43: "确定",
		newlyList_44: "取消"
	},
	hotList: {
		hotList_0: "首页店铺设置",
		hotList_1: "热门",
		hotList_2: "搜索店铺名称/店铺ID",
		// hotList_3: "搜索店铺ID",
		hotList_4: "请选择状态",
		hotList_5: "搜索",
		hotList_6: "批量删除",
		hotList_7: "新增",
		hotList_8: "序号",
		hotList_9: "会社ID",
		hotList_10: "店铺ID",
		hotList_11: "店铺名称",
		hotList_12: "排序",
		hotList_13: "是否推荐",
		hotList_14: "状态",
		hotList_15: "未推荐",
		hotList_16: "推荐中",
		hotList_17: "操作",
		hotList_18: "编辑",
		hotList_19: "删除",
		hotList_20: "会社ID:",
		hotList_21: "店铺ID:",
		hotList_22: "店铺名称:",
		hotList_23: "排序:",
		hotList_24: "是否推荐:",
		hotList_25: "返回",
		hotList_26: "确定",
		hotList_27: "请输入会社ID",
		hotList_28: "请输入店铺ID",
		hotList_29: "请输入店铺名称",
		hotList_30: "请输入排序",
		hotList_31: "请求失败",
		hotList_32: "您确定要删除吗？",
		hotList_33: "提示",
		hotList_34: "删除失败",
		hotList_35: "删除成功",
		hotList_36: "批量删除成功",
		hotList_37: "请您在列表中勾选您要删除的热门信息",
		hotList_38: "确认提交吗？",
		hotList_39: "操作成功",
		hotList_40: "操作失败",
		hotList_41: "您确定要开启推荐状态吗?",
		hotList_42: "您确定要关闭推荐状态吗?",
		hotList_43: "确定",
		hotList_44: "取消"
	},
	addSynthesize: {
		addSynthesize_0: "综合推荐",
		addSynthesize_1: "新增",
		addSynthesize_2: "搜索店铺名称/店铺ID",
		// addSynthesize_3: "搜索店铺ID",
		addSynthesize_4: "请选择分类",
		addSynthesize_5: "搜索",
		addSynthesize_6: "添加所有",
		addSynthesize_7: "店铺ID",
		addSynthesize_8: "店铺名称",
		addSynthesize_9: "会社名称",
		addSynthesize_10: "套餐数量",
		addSynthesize_11: "店铺分类",
		addSynthesize_12: "返点比例",
		addSynthesize_13: "操作",
		addSynthesize_14: "添加",
		addSynthesize_15: "会社ID:",
		addSynthesize_16: "店铺ID:",
		addSynthesize_17: "店铺名称:",
		addSynthesize_18: "排序:",
		addSynthesize_19: "是否推荐:",
		addSynthesize_20: "返回",
		addSynthesize_21: "确定",
		addSynthesize_22: "请输入会社ID",
		addSynthesize_23: "请输入店铺ID",
		addSynthesize_24: "请输入店铺名称",
		addSynthesize_25: "请输入排序",
		addSynthesize_26: "请求失败",
		addSynthesize_27: "您确定要添加所选吗？",
		addSynthesize_28: "提示",
		addSynthesize_29: "操作失败",
		addSynthesize_30: "操作成功",
		addSynthesize_31: "请您在列表中勾选您要添加的店铺信息",
		addSynthesize_32: "确认提交吗？"
	},
	addNewly: {
		addNewly_0: "新店",
		addNewly_1: "新增",
		addNewly_2: "搜索店铺名称",
		addNewly_3: "搜索店铺ID",
		addNewly_4: "请选择分类",
		addNewly_5: "搜索",
		addNewly_6: "添加所有",
		addNewly_7: "店铺ID",
		addNewly_8: "店铺名称",
		addNewly_9: "会社名称",
		addNewly_10: "套餐数量",
		addNewly_11: "店铺分类",
		addNewly_12: "返点比例",
		addNewly_13: "操作",
		addNewly_14: "添加",
		addNewly_15: "会社ID:",
		addNewly_16: "店铺ID:",
		addNewly_17: "店铺名称:",
		addNewly_18: "排序:",
		addNewly_19: "是否推荐:",
		addNewly_20: "返回",
		addNewly_21: "确定",
		addNewly_22: "请输入会社ID",
		addNewly_23: "请输入店铺ID",
		addNewly_24: "请输入店铺名称",
		addNewly_25: "请输入排序",
		addNewly_26: "请求失败",
		addNewly_27: "您确定要添加所选吗？",
		addNewly_28: "提示",
		addNewly_29: "操作失败",
		addNewly_30: "操作成功",
		addNewly_31: "请您在列表中勾选您要添加的店铺信息",
		addNewly_32: "确认提交吗？"
	},
	addHot: {
		addHot_0: "热门",
		addHot_1: "新增",
		addHot_2: "搜索店铺名称",
		addHot_3: "搜索店铺ID",
		addHot_4: "请选择分类",
		addHot_5: "搜索",
		addHot_6: "添加所有",
		addHot_7: "店铺ID",
		addHot_8: "店铺名称",
		addHot_9: "会社名称",
		addHot_10: "套餐数量",
		addHot_11: "店铺分类",
		addHot_12: "返点比例",
		addHot_13: "操作",
		addHot_14: "添加",
		addHot_15: "会社ID:",
		addHot_16: "店铺ID:",
		addHot_17: "店铺名称:",
		addHot_18: "排序:",
		addHot_19: "是否推荐:",
		addHot_20: "返回",
		addHot_21: "确定",
		addHot_22: "请输入会社ID",
		addHot_23: "请输入店铺ID",
		addHot_24: "请输入店铺名称",
		addHot_25: "请输入排序",
		addHot_26: "请求失败",
		addHot_27: "您确定要添加所选吗？",
		addHot_28: "提示",
		addHot_29: "操作失败",
		addHot_30: "操作成功",
		addHot_31: "请您在列表中勾选您要添加的店铺信息",
		addHot_32: "确认提交吗？"
	},
	MsgtempletList: {
		MsgtempletList_0: "消息推送管理",
		MsgtempletList_1: "请搜索消息模板标题/消息模板内容",
		MsgtempletList_2: "请选择消息类型",
		MsgtempletList_3: "搜索",
		MsgtempletList_4: "批量删除",
		MsgtempletList_5: "群发消息",
		MsgtempletList_6: "新增",
		MsgtempletList_7: "序号",
		MsgtempletList_8: "消息模板标题",
		MsgtempletList_9: "消息模板内容",
		MsgtempletList_10: "消息类别",
		MsgtempletList_11: "操作",
		MsgtempletList_12: "查看",
		MsgtempletList_13: "编辑",
		MsgtempletList_14: "删除",
		MsgtempletList_15: "请求失败",
		MsgtempletList_16: "您确定删除吗",
		MsgtempletList_17: "提示",
		MsgtempletList_18: "删除成功",
		MsgtempletList_19: "删除失败",
		MsgtempletList_20: "批量删除成功",
		MsgtempletList_21: "请您在列表中勾选您要删除的推送信息",
		MsgtempletList_22: "返回",
		MsgtempletList_23: "确定",
		MsgtempletList_24: "店铺",
		MsgtempletList_25: "导游",
		MsgtempletList_26: "代理商",
		MsgtempletList_27: "发送",
		MsgtempletList_28: "消息模板",
		MsgtempletList_29: "发消息"
	}, 
	MsgtempletDetails: {
		MsgtempletDetails_0: "查看消息模板",
		MsgtempletDetails_1: "消息模板标题:",
		MsgtempletDetails_2: "消息类别:",
		MsgtempletDetails_3: "消息模板内容:",
		MsgtempletDetails_4: "请输入消息模板标题",
		MsgtempletDetails_5: "请选择消息类别",
		MsgtempletDetails_6: "请输入消息模板内容",
		MsgtempletDetails_7: "请求失败",
		MsgtempletDetails_8: "无数据"
	},
	MsgtempletNews: {
		MsgtempletNews_0: "编辑消息模板",
		MsgtempletNews_1: "消息模板标题:",
		MsgtempletNews_2: "消息类别:",
		MsgtempletNews_3: "消息模板内容:",
		MsgtempletNews_4: "请输入消息模板标题",
		MsgtempletNews_5: "请选择消息类别",
		MsgtempletNews_6: "请输入消息模板内容",
		MsgtempletNews_7: "请求失败",
		MsgtempletNews_8: "无数据",
		MsgtempletNews_9: "编辑成功",
		MsgtempletNews_10: "编辑失败",
		MsgtempletNews_11: "表单验证失败",
		MsgtempletNews_12: "消息模板标题不能为空",
		MsgtempletNews_13: "消息类别不能为空",
		MsgtempletNews_14: "消息模板内容不能为空"
	},
	MsgtempletADD: {
		MsgtempletADD_0: "新增消息模板",
		MsgtempletADD_1: "消息模板标题:",
		MsgtempletADD_2: "消息类别:",
		MsgtempletADD_3: "消息模板内容:",
		MsgtempletADD_4: "请输入消息模板标题",
		MsgtempletADD_5: "请选择消息类别",
		MsgtempletADD_6: "请输入消息模板内容",
		MsgtempletADD_7: "请求失败",
		MsgtempletADD_8: "新增成功",
		MsgtempletADD_9: "新增失败",
		MsgtempletADD_10: "表单验证失败"
	},
	
	MsgtempletSend: {
		MsgtempletSend_0: "群发消息",
		MsgtempletSend_1: "接收对象:",
		MsgtempletSend_2: "请勾选的发送的信息",
		MsgtempletSend_3: "提示",
		MsgtempletSend_4: "发送成功",
		MsgtempletSend_5: "发送失败",
		MsgtempletSend_6: "请求失败",
		MsgtempletSend_7: "表单验证失败",
		MsgtempletSend_8: "接受对象不能为空"
		
	},
	bannerList: {
		bannerList_0: "基础数据设置/轮播图设置",
		bannerList_1: "搜索图标题",
		bannerList_2: "请选择类型",
		bannerList_3: "请选择状态",
		bannerList_4: "搜索",
		bannerList_5: "批量删除",
		bannerList_6: "新增",
		bannerList_7: "序号",
		bannerList_8: "轮播图标题",
		bannerList_9: "类型",
		bannerList_10: "网页链接",
		bannerList_11: "排序",
		bannerList_12: "序号",
		bannerList_13: "状态",
		bannerList_14: "操作",
		bannerList_15: "轮播图片",
		bannerList_16: "编辑",
		bannerList_17: "删除",
		bannerList_18: "外部链接",
		bannerList_19: "店铺ID",
		bannerList_20: "套餐ID",
		bannerList_21: "系统内容",
		bannerList_22: "生效",
		bannerList_23: "失效",
		bannerList_24: "新增轮播图",
		bannerList_25: "编辑轮播图",
		bannerList_26: "轮播图标题:",
		bannerList_27: "类型:",
		bannerList_28: "链接地址:",
		bannerList_29: "图片地址:",
		bannerList_30: "请输入轮播图标题",
		bannerList_31: "请输入类型",
		bannerList_32: "请输入链接或地址",
		bannerList_33: "请输入图片地址",
		bannerList_34: "返回",
		bannerList_35: "确定",
		bannerList_36: "状态:",
		bannerList_37: "确认提交吗？",
		bannerList_38: "提示",
		bannerList_39: "您确定要启用状态吗?",
		bannerList_40: "您确定要停用状态吗?",
		bannerList_41: "确定",
		bannerList_42: "取消",
		bannerList_43: "请求失败",
		bannerList_44: "批量删除成功",
		bannerList_45: "删除失败",
		bannerList_46: "您确定要删除吗？",
		bannerList_47: "提示",
		bannerList_48: "删除成功",
		bannerList_49: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		bannerList_50: "上传产品图片大小不能超过 2MB!",
		bannerList_51: "操作成功",
		bannerList_52: "操作失败",
		bannerList_53: "请您在列表中勾选您要删除的轮播图信息",
		bannerList_54: "设置排序",
		bannerList_55: "请输入排序",
		bannerList_56: "只能输入数字",
		bannerList_57: "店铺ID号:",
		bannerList_58: "套餐ID号:",
		bannerList_59: "系统内容:",
	},
	Dashboard: {
		Dashboard_0: "系统首页",
		Dashboard_1: "本周店铺数量",
		Dashboard_2: "本周导游数量",
		Dashboard_3: "本周代理商数量",
		Dashboard_4: "本周订单成交量",
		Dashboard_5: "同比上周",
		Dashboard_6: "消息",
		Dashboard_7: "查看更多",
		Dashboard_8: "订单销售金额统计",
		Dashboard_9: "近7天成交统计",
		Dashboard_10: "近3天",
		Dashboard_11: "近7天",
		Dashboard_12: "近30天",
		Dashboard_13: "日期",
		Dashboard_14: "销售金额",
		Dashboard_15: "近3天成交统计",
		Dashboard_16: "近30天成交统计",
		Dashboard_17: "注册统计",
		Dashboard_18: "导游",
		Dashboard_19: "店铺",
		Dashboard_20: "代理商",
		Dashboard_21: "请求失败",
		Dashboard_22: "店铺类型",
	},
	VersionList: {
		VersionList_0: "基础数据设置",
		VersionList_1: "版本管理",
		VersionList_2: "请搜索版本号",
		VersionList_3: "移动端",
		VersionList_4: "平台",
		VersionList_5: "搜索",
		VersionList_6: "批量删除",
		VersionList_7: "新增",
		VersionList_8: "序号",
		VersionList_9: "版本号",
		VersionList_10: "移动端",
		VersionList_11: "平台",
		VersionList_12: "版本描述",
		VersionList_13: "版本标题",
		VersionList_14: "操作",
		VersionList_15: "修改",
		VersionList_16: "删除",
		VersionList_17: "请求失败",
		VersionList_18: "返回",
		VersionList_19: "确定",
		VersionList_20: "商铺端",
		VersionList_21: "导游端",
		VersionList_22: "IOS",
		VersionList_23: "Android",
		VersionList_24: "您确定删除吗",
		VersionList_25: "提示",
		VersionList_26: "删除成功",
		VersionList_27: "删除失败",
		VersionList_28: "批量删除成功",
		VersionList_29: "请您勾选要删除的版本信息",
	},
	VersionEdit: {
		VersionEdit_0: "修改版本",
		VersionEdit_1: "版本号:",
		VersionEdit_2: "移动端:",
		VersionEdit_3: "平台:",
		VersionEdit_4: "版本标题:",
		VersionEdit_5: "版本描述:",
		VersionEdit_6: "请求失败",
		VersionEdit_7: "修改成功",
		VersionEdit_8: "修改失败",
		VersionEdit_9: "表单验证失败",
		VersionEdit_10: "版本号不能为空",
		VersionEdit_11: "请选择移动端",
		VersionEdit_12: "请选择平台",
		VersionEdit_13: "请输入版本标题",
		VersionEdit_14: "版本描述不能为空",
		VersionEdit_15: "请输入版本号",
		VersionEdit_16: "请输入版本描述",
		VersionEdit_17: "版本标题不能为空",
		VersionEdit_18: "无数据"
	},
	VersionADD: {
		VersionADD_0: "新增版本",
		VersionADD_1: "版本号:",
		VersionADD_2: "移动端:",
		VersionADD_3: "平台:",
		VersionADD_4: "版本标题:",
		VersionADD_5: "版本描述:",
		VersionADD_6: "请求失败",
		VersionADD_7: "新增成功",
		VersionADD_8: "新增失败",
		VersionADD_9: "表单验证失败",
		VersionADD_10: "版本号不能为空",
		VersionADD_11: "请选择移动端",
		VersionADD_12: "请选择平台",
		VersionADD_13: "请输入版本标题",
		VersionADD_14: "版本描述不能为空",
		VersionADD_15: "请输入版本号",
		VersionADD_16: "请输入版本描述",
		VersionADD_17: "版本标题不能为空",
		VersionADD_18: "无数据"
	},
	wordsList: {
		wordsList_0: "敏感词汇管理",
		wordsList_1: "搜索敏感词",
		wordsList_2: "敏感级别",
		wordsList_3: "开始时间",
		wordsList_4: "结束时间",
		wordsList_5: "搜索",
		wordsList_6: "批量删除",
		wordsList_7: "新增",
		wordsList_8: "序号",
		wordsList_9: "敏感词",
		wordsList_10: "替换词",
		wordsList_11: "创建时间",
		wordsList_12: "操作",
		wordsList_13: "编辑",
		wordsList_14: "删除",
		wordsList_15: "新增敏感词汇",
		wordsList_16: "修改敏感词汇",
		wordsList_17: "敏感词:",
		wordsList_18: "敏感级别:",
		wordsList_19: "请选择",
		wordsList_20: "替换词:",
		wordsList_21: "返回",
		wordsList_22: "确定",
		wordsList_23: "请输入敏感词",
		wordsList_24: "请选择敏感级别",
		wordsList_25: "请输入替换词",
		wordsList_26: "请求失败",
		wordsList_27: "您确定要删除吗？",
		wordsList_28: "提示",
		wordsList_29: "删除失败",
		wordsList_30: "删除成功",
		wordsList_31: "批量删除成功",
		wordsList_32: "请您在列表中勾选您要删除的敏感词信息",
		wordsList_33: "确认提交吗？",
		wordsList_34: "敏感词不能重复新增",
		wordsList_35: "操作失败",
		wordsList_36: "操作成功",
		wordsList_37: "全部",
		wordsList_38: "禁用",
		wordsList_39: "替换"
	},
	PlatformList: {
		PlatformList_0: "基础数据设置",
		PlatformList_1: "平台设置",
		PlatformList_2: "公司名称:",
		PlatformList_3: "邮箱:",
		PlatformList_4: "咨询电话:",
		PlatformList_5: "微信号:",
		PlatformList_6: "公司LOGO:",
		PlatformList_7: "只能上传jpg/png格式文件,文件不能超过50kb",
		PlatformList_8: "官方网站:",
		PlatformList_9: "微博:",
		PlatformList_10: "公司介绍:",
		PlatformList_11: "广告垂询:",
		PlatformList_12: "地址:",
		PlatformList_13: "内容不能为空,长度限制在1-1000个字符之间",
		PlatformList_14: "内容不能为空,长度限制在1-100个字符之间",
		PlatformList_15: "返回",
		PlatformList_16: "提交",
		PlatformList_17: "请输入公司名称",
		PlatformList_18: "请输入邮箱",
		PlatformList_19: "请输入咨询电话",
		PlatformList_20: "请输入微信号",
		PlatformList_21: "请选择图片上传",
		PlatformList_22: "请输入官方网站",
		PlatformList_23: "请输入微博",
		PlatformList_24: "请输入公司介绍",
		PlatformList_25: "请输入广告垂询",
		PlatformList_26: "请输入地址",
		PlatformList_27: "请求失败",
		PlatformList_28: "编辑成功",
		PlatformList_29: "编辑失败",
		PlatformList_30: "公司名称不能为空",
		PlatformList_31: "邮箱不能为空",
		PlatformList_32: "咨询电话不能为空",
		PlatformList_33: "公司介绍不能为空",
		PlatformList_34: "地址不能为空",
		PlatformList_35: "表单验证失败",
	},
	agentDashboard: {
		agentDashboard_0: "系统首页",
		agentDashboard_1: "本周总订单数",
		agentDashboard_2: "同比上周",
		agentDashboard_3: "本周导游数量",
		agentDashboard_4: "本周店铺数量",
		agentDashboard_5: "待完成订单",
		agentDashboard_6: "消息",
		agentDashboard_7: "查看更多",
		agentDashboard_8: "收益统计",
		agentDashboard_9: "近3天",
		agentDashboard_10: "近7天",
		agentDashboard_11: "近30天",
		agentDashboard_12: "本周收益总数",
		agentDashboard_13: "本月收益总数",
		agentDashboard_14: "同比上月",
		agentDashboard_15: "积分总览",
		agentDashboard_16: "已提现",
		agentDashboard_17: "未提现",
		agentDashboard_18: "未结算",
		agentDashboard_19: "订单统计",
		agentDashboard_20: "近一周订单统计",
		agentDashboard_21: "近三天订单统计",
		agentDashboard_22: "近一个月订单统计",
		agentDashboard_23: "店铺销量前五",
		agentDashboard_24: "请求失败",
		agentDashboard_25: "收益金额",
		agentDashboard_26: "成交量",
		agentDashboard_27: "销量:",
	},
	FestivalList: {
		FestivalList_0: "基础数据设置",
		FestivalList_1: "节日设置",
		FestivalList_2: "搜索节日名称",
		FestivalList_3: "搜索",
		FestivalList_4: "新增",
		FestivalList_5: "批量删除",
		FestivalList_6: "序号",
		FestivalList_7: "节日名称",
		FestivalList_8: "节日时间",
		FestivalList_9: "操作",
		FestivalList_10: "编辑",
		FestivalList_11: "删除",
		FestivalList_12: "请求失败",
		FestivalList_13: "返回",
		FestivalList_14: "提交",
		FestivalList_15: "确定",
		FestivalList_16: "您确定删除吗",
		FestivalList_17: "提示",
		FestivalList_18: "删除成功",
		FestivalList_19: "删除失败",
		FestivalList_20: "批量删除成功",
		FestivalList_21: "请选择您要删除的节日信息",
	},
	FestivalADD: {
		FestivalADD_0: "新增成功",
		FestivalADD_1: "新增失败",
		FestivalADD_2: "表单验证失败",
		FestivalADD_3: "请输入节日名称",
		FestivalADD_4: "节日名称不能为空",
		FestivalADD_5: "节日日期不能为空",
		FestivalADD_6: "新增节日",
		FestivalADD_7: "请选择时间"
		
	},
	FestivalNEWS: {
		FestivalNEWS_0: "编辑成功",
		FestivalNEWS_1: "编辑失败",
		FestivalNEWS_2: "无数据",
		FestivalNEWS_3: "表单验证失败",
		FestivalNEWS_4: "请输入节日名称",
		FestivalNEWS_5: "节日名称不能为空",
		FestivalNEWS_6: "节日日期不能为空",
		FestivalNEWS_7: "编辑节日",
		FestivalNEWS_8: "请选择节日时间",
		
	},
	FeedbackList: {
		FeedbackList_0: "基础数据设置",
		FeedbackList_1: "意见反馈",
		FeedbackList_2: "搜索姓名/联系电话",
		FeedbackList_3: "请选择移动端",
		FeedbackList_4: "请选择状态",
		FeedbackList_5: "搜索",
		FeedbackList_6: "序号",
		FeedbackList_7: "姓名",
		FeedbackList_8: "联系电话",
		FeedbackList_9: "用户类型",
		FeedbackList_10: "移动端",
		FeedbackList_11: "反馈时间",
		FeedbackList_12: "状态",
		FeedbackList_13: "操作",
		FeedbackList_14: "查看",
		FeedbackList_15: "标记已处理",
		FeedbackList_16: "标记待处理",
		FeedbackList_17: "请求失败",
		FeedbackList_18: "返回",
		FeedbackList_19: "变更成功",
		FeedbackList_20: "变更失败"
		
	},
	FeedbackDetails: {
		FeedbackDetails_0: "反馈详情",
		FeedbackDetails_1: "联系电话:",
		FeedbackDetails_2: "邮箱号:",
		FeedbackDetails_3: "用户类型:",
		FeedbackDetails_4: "客户端:",
		FeedbackDetails_5: "反馈时间:",
		FeedbackDetails_6: "反馈内容:",
		FeedbackDetails_7: "姓名:",
		FeedbackDetails_8: "请输入姓名:",
		FeedbackDetails_9: "请输入邮箱号",
		FeedbackDetails_10: "请输入联系电话",
		FeedbackDetails_11: "请输入用户类型",
		FeedbackDetails_12: "请输入客户端",
		FeedbackDetails_13: "请输入反馈时间",
		FeedbackDetails_14: "请输入反馈内容",
		FeedbackDetails_15: "无数据",
		FeedbackDetails_16: "请求失败",
		
	},
	shopDashboard: {
		shopDashboard_0: "系统首页",
		shopDashboard_1: "本周订单量",
		shopDashboard_2: "收藏量",
		shopDashboard_3: "待付款订单",
		shopDashboard_4: "已完成订单",
		shopDashboard_5: "上架",
		shopDashboard_6: "下架",
		shopDashboard_7: "全部商品",
		shopDashboard_8: "消息",
		shopDashboard_9: "查看更多",
		shopDashboard_10: "商品总览",
		shopDashboard_11: "近3天",
		shopDashboard_12: "近7天",
		shopDashboard_13: "近30天",
		shopDashboard_14: "订单统计",
		shopDashboard_15: "近一周订单统计",
		shopDashboard_16: "近三天订单统计",
		shopDashboard_17: "近一个月订单统计",
		shopDashboard_18: "成交量",
		shopDashboard_19: "商品销量",
		shopDashboard_20: "销量",
		shopDashboard_21: "资金统计",
		shopDashboard_22: "收益金额",
	},
	userCenter: {
		userCenter_0: "用户管理",
		userCenter_1: "用户编辑",
		userCenter_2: "头像：",
		userCenter_3: "邮箱号：",
		userCenter_4: "请输入邮箱号",
		userCenter_5: "昵称：",
		userCenter_6: "请输入昵称",
		userCenter_7: "姓名：",
		userCenter_8: "请输入姓名",
		userCenter_9: "拼音：",
		userCenter_10: "请输入拼音",
		userCenter_11: "角色：",
		userCenter_12: "请选择角色",
		userCenter_13: "所属店铺：",
		userCenter_14: "请搜索所属店铺",
		userCenter_15: "所属代理商：",
		userCenter_16: "请搜索所属代理商",
		userCenter_17: "电话：",
		userCenter_18: "请输入手机号",
		userCenter_19: "性别：",
		userCenter_20: "男",
		userCenter_21: "女",
		userCenter_22: "返回",
		userCenter_23: "保存",
		userCenter_24: "长度在1-50之间",
		userCenter_25: "只能输入数字以及横线",
		userCenter_26: "请输入邮箱号！邮箱号为必填项",
		userCenter_27: "邮箱格式不正确",
		userCenter_28: "上传产品图片只能是 JPG/PNG/JPEG 格式!",
		userCenter_29: "上传产品图片大小不能超过 2MB!",
		userCenter_30: "请求失败",
		userCenter_31: "无数据",
		userCenter_32: "用户编辑失败",
		userCenter_33: "用户编辑成功",
		userCenter_34: "表单验证失败",
		userCenter_35: "编辑",
		userCenter_36: "是否放弃已改修内容",
		userCenter_37: "提示",
		userCenter_38: "确定",
		userCenter_39: "取消"
	},
	ReservationList: {	
		ReservationList_0:	"基础数据设置",
		ReservationList_1:	"预定须知模板",
		ReservationList_2:	"搜索预定模板名称",
		ReservationList_3:	"请选择状态",
		ReservationList_4:	"搜索",
		ReservationList_5:	"批量删除",
		ReservationList_6:	"新增",
		ReservationList_7:	"序号",
		ReservationList_8:	"预定模板名称",
		ReservationList_9:	"模板内容",
		ReservationList_10:	"创建时间",
		ReservationList_11:	"状态",
		ReservationList_12:	"操作",
		ReservationList_13:	"编辑",
		ReservationList_14:	"删除",
		ReservationList_15:	"使用",
		ReservationList_16:	"停用",
		ReservationList_17:	"请求失败",
		ReservationList_18:	"确定",
		ReservationList_19:	"提交",
		ReservationList_20:	"返回",
		ReservationList_21:	"您确定删除吗",
		ReservationList_22:	"提示",
		ReservationList_23:	"删除成功",
		ReservationList_24:	"删除失败",
		ReservationList_25:	"批量删除成功",
		ReservationList_26:	"请选择您要删除的预定须知信息",
	},
	ReservationADD: {
		ReservationADD_0: "新增预订模板",
		ReservationADD_1: "预定模板名称:",
		ReservationADD_2: "模板内容:",
		ReservationADD_3: "状态:",
		ReservationADD_4: "请求失败",
		ReservationADD_5: "新增成功",
		ReservationADD_6: "新增失败",
		ReservationADD_7: "表单验证失败",
		ReservationADD_8: "请输入预定模板名称",
		ReservationADD_9: "请输入模板内容",
		ReservationADD_10: "预定模板名称不能为空",
		ReservationADD_11: "模板内容不能为空",
		ReservationADD_12: "状态不能为空",
		ReservationADD_13: "请选择状态"
	},
	ReservationEdit: {
		
		ReservationEdit_0: "编辑预订模板",
		ReservationEdit_1: "预定模板名称:",
		ReservationEdit_2: "模板内容:",
		ReservationEdit_3: "状态:",
		ReservationEdit_4: "请求失败",
		ReservationEdit_5: "编辑成功",
		ReservationEdit_6: "编辑失败",
		ReservationEdit_7: "表单验证失败",
		ReservationEdit_8: "请输入预定模板名称",
		ReservationEdit_9: "请输入模板内容",
		ReservationEdit_10: "预定模板名称不能为空",
		ReservationEdit_11: "模板内容不能为空",
		ReservationEdit_12: "状态不能为空",
		ReservationEdit_13: "请选择状态"
	},
T13011: {
		T13011_0: "伝票ID",
		T13011_1: "担当者",
		T13011_2: "入力日",
		T13011_3: "入荷伝票ID",
		T13011_4: "移動元",
		T13011_5: "備考",
		T13011_6: "移動先",
		T13011_7: "JAN ",
		T13011_8: "数量合計",
		T13011_9: "メーカー",
		T13011_10: "大分類 ",
		T13011_11: "中分類",
		T13011_12: "小分類 ",
		T13011_13: "品番",
		T13011_14: "品名",
		T13011_15: "品名2",
		T13011_16: "属性1 ",
		T13011_17: "属性2",
		T13011_18: "属性3 ",
		T13011_19: "標準価格",
		T13011_20: "数量",
		T13011_21: "金額",
		T13011_22: "備考",
		T13011_23: "金額",
		T13011_24: "数据保存成功。",
		T13011_25: "数据保存失败。",
		T13011_26: "请求失败",
		T13011_27: "商品移动",
		T13011_28: "盘点中，无法进行商品调拨。\n盘点结束后，请再次录入。",
		T13011_29: "无数据",
		T13011_30: "運送業者",
		T13011_31: "送り状番号",
		T13011_32: "输入的 JAN 不存在。", 
		T13011_33: "表单验证失败",
		T13011_34: "リセット",
		T13011_35: "登 録",		
		T13011_36: "即時入庫",
		T13011_37: "删除",
	},
	T13021: {
		T13021_0: "商品移动 ",		
		T13021_1:"メーカー",
		T13021_2:"移動元",
		T13021_3:"伝票ID",
		T13021_4:"状態",
		T13021_5:"JAN",
		T13021_6:"移動先",
		T13021_7:"キーワード",
		T13021_8:"備考",
		T13021_9:"品番",
		T13021_10:"処理日時",
		T13021_11:"品名",
		T13021_12:"移動伝票ID",
		T13021_13:"移動状態 ",
		T13021_14:"移動元 ",
		T13021_15:"移動先 ",
		T13021_16:"入力者 ",
		T13021_17:"入力日 ",
		T13021_18:"発送者 ",
		T13021_19:"発送日 ",
		T13021_20:"入庫者 ",
		T13021_21: "入庫日 ",
		T13021_22: "送り状ID ",
		T13021_23:"リセット",
		T13021_24:"导出Excel",
		T13021_25:"",
		T13021_26:"搜索",
		T13021_27:"发送",
		T13021_28:"入库",
		T13021_29:"再发行",
		T13021_30:"照会",
		T13021_31:"编辑",
		T13021_32:"删除",
		T13021_33:"品名",
		T13021_34:"削除も表示",
		T13021_35:"自店に関係あるものだけ表示",
		T13021_36: "開始日付",
		T13021_37: "終了日付",
		T13021_38: "请求失败",
		T13021_39: "操作",
		T13021_40: "您确定要操作吗？",
		T13021_41: "提示",
		T13021_42: "操作失败",
		T13021_43: "操作成功",
		T13021_table0: "JAN",
		T13021_table1: "メーカー",		
		T13021_table2: "大分類",
		T13021_table3: "中分類",
		T13021_table4: "小分類",		
		T13021_table5: "品番",
		T13021_table6: "品名",
		T13021_table7: "品名2",		
		T13021_table8: "標準価格",
		T13021_table9: "数量",
		T13021_table10: "金額",		
		T13021_table11: "備考",
		T13021_table12: "删除标志",
		T13021_table13: "社内JAN",
		T13021_44: "此操作将导出excel文件, 是否继续?",
		T13021_45: "确定",
		T13021_46: "取消",
		T13021_47: "移動元店舗",
		T13021_48: "移動先店舗",
		T13021_49: "ブランド",
		T13021_50: "サイズ",
		T13021_51: "カラー",
		T13021_52: "移動リスト",		
		T13021_53: "明細行を選択してください。",
		},

}
